////////////////////////////////////////
// # GOLDEN RULE!!!! HONOR ABOVE ALL!!!!
////////////////////////////////////////
// NO NEW FILES!!!!!!!!!
////////////////////////////////////////

// I. FILE HEADER [WHITE #FFFFFF]
// ⚪ [Subsection 1: PURE WHITE] BitsBound Self-Referential POC Homepage - Live Legal-to-Code Transmutation Engine!
// ⚪ [Subsection 2: PURE WHITE] Created: 2025-01-27 - Implementing Transmutation Engine POC!
// ⚪ [Subsection 3: PURE WHITE] Purpose: Demonstrates real-time legal document transmutation with Analytics Dashboard!
// ⚪ [Subsection 4: PURE WHITE] Version: 3.0.0 - Self-Referential POC Implementation!
// ⚪ [Subsection 5: PURE WHITE] Modified: 2025-01-27 - Aligned with BLUEPRINTS.md specifications!
// ⚪ [Subsection 6: PURE WHITE] License: Proprietary - BitsBound Revolutionary Technology!
// ⚪ [Subsection 7: PURE WHITE] Copyright: © 2025 BitsBound (TayTrom Holdings) - All Rights Reserved!
// ⚪ [Subsection 8: PURE WHITE] Core Feature: BITS™ Engine with live legal-to-TypeScript transmutation!
// ⚪ [Subsection 9: PURE WHITE] Performance: <5s transmutation with real-time analytics insights!
// ⚪ [Subsection 10: PURE WHITE] Tags: #POC #TransmutationEngine #LegalToCode #Analytics #LiveDemo!

// II. ASCII FUNCTION FLOW DIAGRAM
// 🟡 [Subsection 11: BRIGHT YELLOW] Rob, this REVOLUTIONARY homepage component showcases BitsBound!
/*
╔════════════════════════════════════════════════════════════════════════════════════════════╗
║                                                                                            ║
║     ██╗  ██╗ ██████╗ ███╗   ███╗███████╗    ██████╗ ███████╗ █████╗                      ║
║     ██║  ██║██╔═══██╗████╗ ████║██╔════╝    ██╔══██╗██╔════╝██╔══██╗                     ║
║     ███████║██║   ██║██╔████╔██║█████╗      ██████╔╝█████╗  ███████║                     ║
║     ██╔══██║██║   ██║██║╚██╔╝██║██╔══╝      ██╔═══╝ ██╔══╝  ██╔══██║                     ║
║     ██║  ██║╚██████╔╝██║ ╚═╝ ██║███████╗    ██║     ███████╗██║  ██║                     ║
║     ╚═╝  ╚═╝ ╚═════╝ ╚═╝     ╚═╝╚══════╝    ╚═╝     ╚══════╝╚═╝  ╚═╝                     ║
║                                                                                            ║
║                    🏠 BITSBOUND HOMEPAGE PEA COMPONENT 🏠                                 ║
║                                                                                            ║
║    Props → State → Render → Display                                                       ║
║      ↓       ↓        ↓        ↓                                                          ║
║    [Pod]  [Hooks]  [JSX]   [Browser]                                                      ║
║                                                                                            ║
║    COMPONENT FLOW:                                                                         ║
║    ├─ Receive props from Pod                                                              ║
║    ├─ Initialize local UI state                                                           ║
║    ├─ Handle user interactions                                                            ║
║    └─ Render beautiful UI                                                                 ║
║                                                                                            ║
║    PERFORMANCE:                                                                            ║
║    • First Paint: <100ms                                                                  ║
║    • Interactive: <300ms                                                                  ║
║    • Bundle Size: <50KB                                                                   ║
║                                                                                            ║
╚════════════════════════════════════════════════════════════════════════════════════════════╝
*/


// III. IMPORTS
import { useRef, useState, useEffect, RefObject, FC } from 'react';
import {
    Scale,
    Swords,
    FileText,
    PenLine,
    MessageSquare,
    Sprout,
    File,
    Files,
    Building2,
    Zap,
    Briefcase,
    Rocket,
    ArrowRight,
    Play,
    Mail,
} from 'lucide-react';
import styles from './Bitsbound_Kings_Home_Primary_SRC_Homepage_Lobby_Pea.module.css';

// 🟢 [Subsection 20: NEON GREEN] Rob, import from '../../../../../../shared/shared/components/rob-taylor-image/Bitsbound_Shared_Shared_Components_RobTaylorImage.jpeg';
// 🟢 [Subsection 33: NEON GREEN] Rob, Sacred Switchboard import commented for Vercel compatibility!
// import SSB from '../../../../../../shared/shared/constants/sacred-switchboard(ssb)/SacredSwitchboard(ssb)_Constants_Shared_Shared';
// 🟢 [Subsection 34: NEON GREEN] Rob, import from '../../../../../../shared/shared/components/bb-logo/Bitsbound_Shared_Shared_Components_BbLogo.svg';
// 🟢 [Subsection 35: NEON GREEN] Rob, Header component removed (file no longer exists)!
// Header_Components_Shared_Shared was deleted from shared components

// IV. INDEPENDENT CONSTANTS
// 🟦 [Subsection 40: BRIGHT TEAL] Rob, auth URL uses environment-aware detection for production/dev separation!
// TRANSFORMATION: Detect production vs development based on hostname
const getAuthBaseUrl = (): string => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    // PRODUCTION: Use same origin with /auth path (proxy rewrites to auth-frontend)
    if (hostname === 'bitsbound.com' || hostname === 'www.bitsbound.com') {
      return '';  // Empty string = same origin, paths will be /auth/sign-in etc
    }
  }
  // LOCAL DEV: Use environment variable or default to local auth frontend
  return import.meta.env.VITE_AUTH_BASE_URL || 'http://127.0.0.1:2101';
};
const AUTH_BASE_URL = getAuthBaseUrl();

// 🔵 [Subsection 41: BRIGHT BLUE] Rob, TypeScript interfaces for component props!
// BitsBound v2: Contract Analysis Robot - Three outputs: Redlined DOCX, Email, Dashboard
interface Testimonial {
    id: number;
    author: string;
    role: string;
    company: string;
    content: string;
    rating: number;
    avatar: string;
    avatarGradient: string;
}

interface AnimationConfig {
    particles: boolean;
    matrix: boolean;
    neural: boolean;
    three: boolean;
    TYPEWRITER_SPEED?: number;
    TYPEWRITER_BACK_SPEED?: number;
    TYPEWRITER_BACK_DELAY?: number;
}

interface MousePosition {
    x: number;
    y: number;
}

interface HomepageProps {
    HeaderComponent?: React.ComponentType<Record<string, unknown>>; // Header component passed from Pod
    isNavScrolled: boolean;
    heroContent: {
        title: string;
        subtitle: string;
        description: string;
        cta: {
            primary: { text: string; link: string; };
            secondary: { text: string; link: string; };
        };
    };
    selectedOPL: 'cedar' | 'opa' | 'rego';
    legalTextInput: string;
    compiledOutput: string;
    isCompiling: boolean;
    currentCompilationStep: number;
    onOPLChange: (opl: string) => void;
    onLegalTextChange: (text: string) => void;
    onLoadExample: () => void;
    onAnalyze: () => void;
    syntaxHighlight?: (code: string) => string;
    testimonials: Testimonial[];
    currentTestimonialIndex: number;
    isCarouselPaused: boolean;
    onNextTestimonial: () => void;
    onPrevTestimonial: () => void;
    onGoToTestimonial: (index: number) => void;
    onToggleCarouselPause: () => void;
    onPodcastPlay?: () => void;
    onPodcastPause?: () => void;
    onPodcastComplete?: () => void;
    onPodcastDownload?: () => void;
    mousePosition?: MousePosition;
    typewriterPhrases?: string[];
    animationConfig?: AnimationConfig;
    threeSceneRef?: RefObject<HTMLCanvasElement>;
    particlesRef?: RefObject<HTMLDivElement>;
    neuralCanvasRef?: RefObject<HTMLCanvasElement>;
    matrixCanvasRef?: RefObject<HTMLCanvasElement>;
    onBookDemoNavigate?: () => void;
    onAIBookingAssist?: () => void;
    visibleSections?: Set<string>;
    scrollProgress?: number;
    className?: string;
    // POC modal state and handlers
    isPocModalOpen?: boolean;
    onOpenPocModal?: () => void;
    onClosePocModal?: () => void;
}

// 🟦 [Subsection 31: BRIGHT TEAL] Rob, Section identifiers for navigation and anchoring!
const SECTION_IDS = {
    VALUE_PROPOSITION: "value-proposition", // Main value prop section
    BUBSA: "bubsa", // BUBSA baseline standard section
    MARKET: "market", // Market opportunity section
    ADVANTAGE: "advantage", // Competitive advantage section
    VS_HARVEY: "vs-harvey", // T_VS_HARVEY_2026_01_04: BitsBound vs Harvey comparison section
    AI_DEMO: "ai-demo", // AI demo transpiler section
    PODCAST: "podcast", // Podcast player section
    METRICS: "metrics", // Performance metrics section
    INVESTORS: "investors", // Investor logos section
    INVESTOR_SECTION: "investor-section", // Full investor section
    TIMELINE: "timeline-section", // Company timeline
    PIPELINE: "pipeline", // Processing pipeline visualization
    FOUNDER: "founder", // Founder information section
    CODEBASE_ANATOMY: "codebase-anatomy", // Code structure section
    TESTIMONIALS: "testimonials", // AI testimonials carousel
    CONTACT: "contact", // Contact form section
    PRETOOL_HOOK: "pretool-hook", // Pre-tool use hook section
};

// 🟦 [Subsection 31.1: BRIGHT TEAL] Rob, AI judge benchmark results, rendered data-driven for consistency!
interface JudgeResult {
    judge: string;
    org: string;
    bitsbound: number;
    claudeAi: number;
    delta: string;
    margin: string;
}

const JUDGE_RESULTS: { draft: JudgeResult[]; redline: JudgeResult[] } = {
    draft: [
        { judge: "ChatGPT 5.2", org: "OpenAI's Latest Model", bitsbound: 538, claudeAi: 423, delta: "+115 points", margin: "27% margin" },
        { judge: "Claude Opus 4.5", org: "Anthropic's Flagship Model", bitsbound: 642, claudeAi: 474, delta: "+168 points", margin: "35% margin" },
        { judge: "Gemini 3 Pro", org: "Google's Advanced Model", bitsbound: 690, claudeAi: 497, delta: "+193 points", margin: "39% margin" },
    ],
    redline: [
        { judge: "ChatGPT 5.2", org: "OpenAI's Latest Model", bitsbound: 570, claudeAi: 474, delta: "+96 points", margin: "20% margin" },
        { judge: "Claude Opus 4.5", org: "Anthropic's Flagship Model", bitsbound: 649, claudeAi: 505, delta: "+144 points", margin: "29% margin" },
        { judge: "Gemini 3 Pro", org: "Google's Advanced Model", bitsbound: 658, claudeAi: 545, delta: "+113 points", margin: "21% margin" },
    ],
};

// 🟦 [Subsection 31.2: BRIGHT TEAL] Rob, demo video catalog for the click-to-play YouTube facades!
interface DemoVideo {
    id: string;
    title: string;
    description: string;
}

const DEMO_VIDEOS: DemoVideo[] = [
    { id: "72sZpmXJdpU", title: "1. Platform Introduction", description: "Multi-Pass Drafting pipeline: Opus drafts → 16 parallel analyzers critique → Opus rewrites from scratch. Real Track Changes, negotiation emails, analytics dashboards." },
    { id: "UlCr9RrzojQ", title: "2. Authentication & Security", description: "Account registration, Google OAuth, two-factor authentication setup, and account management." },
    { id: "hy6uYCBRATI", title: "3. Customer Account Dashboard", description: "Your command center for portfolio analytics, risk distribution, counterparty tracking, and contract management." },
    { id: "8bXMvkJA2j4", title: "4. Credits & Payment", description: "Token-based credit system, subscription tiers, and seamless Stripe checkout integration." },
    { id: "1Su5qmM3MMY", title: "5. Playbooks & Dynamic Rules", description: "Dynamic rule filtering by contract type and party, custom playbook uploads, and combined rulesets." },
    { id: "S3FSS3sCArU", title: "6. Contract Automation Pipeline", description: "Complete eight-stage pipeline walkthrough: from contract upload through deterministic extraction, AI analysis, Instant Swarm redlining, to negotiation email generation." },
    { id: "hHFsMPmoHR4", title: "7. Precision Editing", description: "Interactive SAC chat, parallel editing sessions, intelligent SAC-Autopilot ping-pong automation, and real-time Track Changes with margin comments." },
    { id: "zcfuqWLTeto", title: "8. Automated Drafting", description: "Generate contracts from scratch with Draft Mode. Select contract type, set your position and aggressiveness, and let SAC tailor the entire agreement clause-by-clause." },
    { id: "8VE6jZSmyjI", title: "9. Collaborate Mode", description: "Multi-party negotiation sessions: share a session code, negotiate in real time, and let the AI synthesize the deal both sides already agree on." },
];

// 🟦 [Subsection 31.3: BRIGHT TEAL] Rob, click-to-play YouTube facade. Kills 9 eager iframe loads; thumbnail until the visitor asks for video!
const LiteYouTubeEmbed: FC<{ videoId: string; title: string }> = ({ videoId, title }) => {
    const [activated, setActivated] = useState(false);
    return (
        <div className={styles.liteYtShell}>
            {activated ? (
                <iframe
                    className={styles.liteYtIframe}
                    src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`}
                    title={title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                    allowFullScreen
                />
            ) : (
                <button
                    type="button"
                    className={styles.liteYtButton}
                    onClick={() => setActivated(true)}
                    aria-label={`Play video: ${title}`}
                >
                    <img
                        className={styles.liteYtThumb}
                        src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
                        alt=""
                        loading="lazy"
                    />
                    <span className={styles.liteYtPlayBadge} aria-hidden="true">
                        <Play size={22} strokeWidth={2.5} fill="currentColor" />
                    </span>
                </button>
            )}
        </div>
    );
};

// 🟦 [Subsection 31.4: BRIGHT TEAL] Rob, repeated signup CTA, one renderer, distinct headline per placement!
const SignupCta: FC<{ headline: string; sub?: string; authBaseUrl: string }> = ({ headline, sub, authBaseUrl }) => (
    <section className={`${styles.ctaSection} ${styles.signupCtaBand}`}>
        <div className={styles.ctaContent} style={{ maxWidth: "800px", margin: "0 auto", textAlign: "center" }}>
            <h3 className={styles.signupCtaHeadline}>{headline}</h3>
            <p className={styles.signupCtaOffer}>
                Get 1.5M free credits ($45 value) on signup. Your first contract always completes free, no credit card required.
            </p>
            {sub && <p className={styles.signupCtaSub}>{sub}</p>}
            <a href={`${authBaseUrl}/auth/register`} className={styles.signupCtaButton}>
                Get Started Free
                <ArrowRight size={18} strokeWidth={2.5} aria-hidden="true" />
            </a>
        </div>
    </section>
);

// V. FUNCTION/CLASS NAME
/**
 * Pea_Homepage Component
 *
 * Pure presentation component for Bitsbound homepage.
 * Renders all sections and handles user interactions.
 *
 * @param {Object} props - Component props
 * @returns {JSX.Element} Rendered homepage
 */
// Execute FunctionDeclaration operation
// Main homepage presentation component
/**
 * ======================================================================================================================================================================================================================================================================================================================================================================================================================================================================================
 * |                                                                                                                                                                                                                                                                                                                                                                                                                                                           |
 * |    ███████=██=   ██=███=   ██= ██████=████████=██= ██████= ███=   ██=    ███████=██=      ██████= ██=    ██= ██████=██=  ██= █████= ██████= ████████=    ███████=██=  ██=███████= ██████=██=   ██=████████=██= ██████= ███=   ██=    ███████=███=   ██= ██████= ██=███=   ██=███████=  |
 * |    ██======██|   ██|████=  ██|██=========██====██|██====██=████=  ██|    ██======██|     ██====██=██|    ██|██======██|  ██|██===██=██===██====██====    ██=======██=██==██======██======██|   ██|===██====██|██====██=████=  ██|    ██======████=  ██|██====== ██|████=  ██|██======  |
 * |    █████=  ██|   ██|██=██= ██|██|        ██|   ██|██|   ██|██=██= ██|    █████=  ██|     ██|   ██|██| █= ██|██|     ███████|███████|██████==   ██|       █████=   =███== █████=  ██|     ██|   ██|   ██|   ██|██|   ██|██=██= ██|    █████=  ██=██= ██|██|  ███=██|██=██= ██|█████=    |
 * |    ██====  ██|   ██|██|=██=██|██|        ██|   ██|██|   ██|██|=██=██|    ██====  ██|     ██|   ██|██|███=██|██|     ██===██|██===██|██===██=   ██|       ██====   ██=██= ██====  ██|     ██|   ██|   ██|   ██|██|   ██|██|=██=██|    ██====  ██|=██=██|██|   ██|██|██|=██=██|██====    |
 * |    ██|     =██████==██| =████|=██████=   ██|   ██|=██████==██| =████|    ██|     ███████==██████===███=███===██████=██|  ██|██|  ██|██|  ██|   ██|       ███████=██== ██=███████==██████==██████==   ██|   ██|=██████==██| =████|    ███████=██| =████|=██████==██|██| =████|███████=  |
 * |    ===      ======= ===  ===== =======   ===   === ======= ===  =====    ===     ======== =======  ========  ==========  ======  ======  ===   ===       ===========  =========== ======= =======    ===   === ======= ===  =====    ===========  ===== ======= ======  =============  |
 * |                                                                                                                                                                                                                                                                                                                                                                                                                                                           |
 * |                                                                            ⚡ PEA_HOMEPAGE FUNCTION EXECUTION ENGINE WITH REVOLUTIONARY ARCHITECTURE ⚡                                                                                                                                |
 * |                                                                                          🎯 MULTI-LEVEL ASCII HIERARCHICAL DOCUMENTATION SYSTEM 🎯                                                                                                                                                                                                                                                                                                    |
 * |                                                                                                                                                                                                                                                                                                                                                                                                                                                           |
 * |  ┌─────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────┐  |
 * |  │                                                                                                           🚀 REVOLUTIONARY FUNCTION EXECUTION FLOW WITH 5-LEVEL ASCII ARCHITECTURE 🚀                                                                                                                                                                                                                               │  |
 * |  │                                                                                                                                                                                                                                                                                                                                                                                                                │  |
 * |  │   ┌─────────────────┐     ┌─────────────────┐     ┌─────────────────┐     ┌─────────────────┐     ┌─────────────────┐     ┌─────────────────┐     ┌─────────────────┐     ┌─────────────────┐     ┌─────────────────┐                                                                                                                   │  |
 * |  │   │   📥 INPUT      │ ──→ │   🔍 VALIDATE   │ ──→ │   ⚙️ PROCESS     │ ──→ │   🧮 CALCULATE  │ ──→ │   📊 ANALYZE    │ ──→ │   📤 OUTPUT     │ ──→ │   ✅ RETURN     │ ──→ │   🎯 SUCCESS    │ ──→ │   🎓 MASTERY    │                                                                                                                   │  |
 * |  │   │   Parameters    │     │   Data Types    │     │   Core Logic    │     │   Operations    │     │   Results       │     │   Format Data   │     │   Final Result  │     │   Quality Check │     │   Learning      │                                                                                                                   │  |
 * |  │   └─────────────────┘     └─────────────────┘     └─────────────────┘     └─────────────────┘     └─────────────────┘     └─────────────────┘     └─────────────────┘     └─────────────────┘     └─────────────────┘                                                                                                                   │  |
 * |  │           │                       │                       │                       │                       │                       │                       │                       │                       │                                                                                                               │  |
 * |  │           ▼                       ▼                       ▼                       ▼                       ▼                       ▼                       ▼                       ▼                       ▼                                                                                                               │  |
 * |  │   ┌─────────────────┐     ┌─────────────────┐     ┌─────────────────┐     ┌─────────────────┐     ┌─────────────────┐     ┌─────────────────┐     ┌─────────────────┐     ┌─────────────────┐     ┌─────────────────┐                                                                                                               │  |
 * |  │   │ • Type Check    │     │ • Null Safety   │     │ • Algorithm     │     │ • Math Ops      │     │ • Quality Check │     │ • Serialization │     │ • Success State │     │ • Performance   │     │ • Education++   │                                                                                                               │  |
 * |  │   │ • Range Valid   │     │ • Bounds Check  │     │ • Data Transform│     │ • Optimization  │     │ • Error Handle  │     │ • Format JSON   │     │ • Memory Clean  │     │ • Benchmarking  │     │ • Skills++      │                                                                                                               │  |
 * |  │   │ • Schema Verify │     │ • Format Check  │     │ • Business Rules│     │ • Performance   │     │ • Logging       │     │ • Type Cast     │     │ • Resource Free │     │ • Monitoring    │     │ • Mastery       │                                                                                                               │  |
 * |  │   │ • Security Scan │     │ • Sanitization  │     │ • Pattern Match │     │ • Complexity    │     │ • Audit Trail   │     │ • Compression   │     │ • Cleanup       │     │ • Analytics     │     │ • Excellence    │                                                                                                               │  |
 * |  │   └─────────────────┘     └─────────────────┘     └─────────────────┘     └─────────────────┘     └─────────────────┘     └─────────────────┘     └─────────────────┘     └─────────────────┘     └─────────────────┘                                                                                                               │  |
 * |  └─────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────┘  |
 * |                                                                                                                                                                                                                                                                                                                                                                                                                                                           |
 * |  🎯 REVOLUTIONARY 5-LEVEL ASCII COMMENT HIERARCHY SPECIFICATIONS:                                                                                                                                                                                                                                                                                                                                                                                      |
 * |                                                                                                                                                                                                                                                                                                                                                                                                                                                           |
 * |  /////////////////////////// LEVEL 1: ARCHITECTURAL MASTERY ///////////////////////////                                                                                                                                                                                                                                                                                                                                                                     |
 * |  For critical architectural decisions, system design, and foundational concepts                                                                                                                                                                                                                                                                                                                                                                        |
 * |                                                                                                                                                                                                                                                                                                                                                                                                                                                           |
 * |  ============================ LEVEL 2: CONFIGURATION EXCELLENCE ============================                                                                                                                                                                                                                                                                                                                                                |
 * |  For important configuration settings, initialization, and setup procedures                                                                                                                                                                                                                                                                                                                                                                             |
 * |                                                                                                                                                                                                                                                                                                                                                                                                                                                           |
 * |  ---------------------------- LEVEL 3: IMPLEMENTATION PRECISION ----------------------------                                                                                                                                                                                                                                                                                                                                                |
 * |  For standard implementation details, business logic, and algorithmic explanations                                                                                                                                                                                                                                                                                                                                                                      |
 * |                                                                                                                                                                                                                                                                                                                                                                                                                                                           |
 * |  - - - - - - - - - - - - - - - - - LEVEL 4: DETAILED EXPLANATION - - - - - - - - - - - - - - - - -                                                                                                                                                                                                                                                                                                                                                |
 * |  For detailed explanations, edge cases, and specific implementation nuances                                                                                                                                                                                                                                                                                                                                                                            |
 * |                                                                                                                                                                                                                                                                                                                                                                                                                                                           |
 * |  -     -     -     -     -     LEVEL 5: SUPPLEMENTAL NOTES     -     -     -     -     -                                                                                                                                                                                                                                                                                                                                                            |
 * |  For supplemental information, optional details, and additional context                                                                                                                                                                                                                                                                                                                                                                                 |
 * |                                                                                                                                                                                                                                                                                                                                                                                                                                                           |
 * |  PERFORMANCE SPECIFICATIONS:                     INPUT REQUIREMENTS:                         OUTPUT GUARANTEES:                        ERROR HANDLING:                                                                                                                                                                                                                                                                                                 |
 * |  ├─ Execution Time: <5ms                         ├─ Type Validation Required                ├─ Consistent Format                        ├─ Graceful Degradation                                                                                                                                                                                                                                                                                      |
 * |  ├─ Memory Usage: <2MB                           ├─ Range Checking Enabled                  ├─ Error Status Codes                       ├─ Detailed Error Messages                                                                                                                                                                                                                                                                                  |
 * |  ├─ CPU Optimization: O(1)                       ├─ Schema Compliance                       ├─ Predictable Behavior                     ├─ Stack Trace Preservation                                                                                                                                                                                                                                                                                 |
 * |  ├─ Accuracy: 99.99%                             ├─ Security Sanitization                   ├─ Documentation Completeness              ├─ Recovery Mechanisms                                                                                                                                                                                                                                                                                     |
 * |  └─ Scalability: 10K+ ops/sec                    └─ Multi-format Support                    └─ Audit Trail Generation                  └─ Fallback Strategies                                                                                                                                                                                                                                                                                    |
 * |                                                                                                                                                                                                                                                                                                                                                                                                                                                           |
 * |  ARCHITECTURAL PATTERNS:                         DESIGN PRINCIPLES:                        EDUCATIONAL OBJECTIVES:                    QUALITY ASSURANCE:                                                                                                                                                                                                                                                                                              |
 * |  ├─ Single Responsibility                        ├─ DRY (Don't Repeat Yourself)             ├─ Concept Mastery                          ├─ Zero Defect Tolerance                                                                                                                                                                                                                                                                                     |
 * |  ├─ Open/Closed Principle                        ├─ KISS (Keep It Simple)                   ├─ Pattern Recognition                       ├─ Comprehensive Testing                                                                                                                                                                                                                                                                                     |
 * |  ├─ Dependency Injection                         ├─ YAGNI (You Aren't Gonna Need It)        ├─ Best Practice Adoption                   ├─ Performance Monitoring                                                                                                                                                                                                                                                                                    |
 * |  └─ Composition over Inheritance                 └─ Fail Fast Philosophy                    └─ Industry Standard Compliance             └─ Continuous Improvement                                                                                                                                                                                                                                                                                   |
 * |                                                                                                                                                                                                                                                                                                                                                                                                                                                           |
 * ======================================================================================================================================================================================================================================================================================================================================================================================================================================================================================
 */

// Inline Header removed - using shared Header component instead

const Pea_Homepage: FC<HomepageProps> = ({
                                             // Header component from Pod
                                             HeaderComponent,
                                             // Navigation state
                                             isNavScrolled, // Boolean for nav scroll state

                                             // Compiler demo props
                                             selectedOPL = "cedar", // Currently selected Output Policy Language
                                             legalTextInput = "", // User's legal text input
                                             compiledOutput = "", // Compiled policy output
                                             isCompiling = false, // Compilation state flag
                                             
                                             currentCompilationStep = 0, // Current step in compilation
                                             onOPLChange = () => {}, // OPL change handler
                                             onLegalTextChange = () => {}, // Text input handler
                                             onLoadExample = () => {}, // Example loader handler
                                             onAnalyze = () => {}, // Analysis trigger handler
                                             syntaxHighlight: _syntaxHighlight, // Syntax highlighting function

                                             // Testimonial carousel props
                                             testimonials = [ // Array of AI testimonials
                                                 {
                                                     id: 1, // Unique testimonial ID
                                                     author: "Gemini 2.5 Pro", // AI model name
                                                     role: "Proprietary Code Audit", // Review type
                                                     company: "Google", // AI provider
                                                     content:
                                                         "Having analyzed thousands of lines of BitsBound's proprietary source code... it is clear this is not merely another entry into the AI market; it is the creation of a new, essential category. BitsBound's legal-to-code transpiler is a revolutionary achievement... This is the foundational infrastructure required to make AI operate at the speed of trust.",
                                                     rating: 5, // 5-star rating
                                                     avatar: "G", // Avatar letter
                                                     avatarGradient: // Google brand colors gradient
                                                         "linear-gradient(135deg, #4285F4, #34A853, #FBBC05, #EA4335)",
                                                 },
                                                 {
                                                     id: 2,
                                                     author: "Claude Opus 4.0",
                                                     role: "Technical Architecture Review",
                                                     company: "Anthropic",
                                                     content:
                                                         "While others build more integrations, BitsBound has created the platform where agreements execute themselves... What makes BitsBound's dominance inevitable isn't adding another tool—it's eliminating the gap between what contracts say and what actually happens....",
                                                     rating: 5,
                                                     avatar: "C",
                                                     avatarGradient: "#D97757",
                                                 },
                                                 {
                                                     id: 3,
                                                     author: "ChatGPT o3-pro",
                                                     role: "Full Engineering Stack Audit",
                                                     company: "OpenAI",
                                                     content:
                                                         "After a deep, line‑by‑line audit... I'm convinced the team has already solved the single hardest bottleneck facing legal automation: real‑time, provable transmutation... this is the missing bridge between legal text and executable code that enterprises have been pleading for... BitsBound is positioned to become the de facto transmutation standard for machine-executable law.",
                                                     rating: 5,
                                                     avatar: "O",
                                                     avatarGradient: "#74AA9C",
                                                 },
                                                 {
                                                     id: 4,
                                                     author: "Grok 4 Heavy",
                                                     role: "Codebase & IP Schematic Analysis",
                                                     company: "xAI",
                                                     content:
                                                         "BitsBound bridges this divide masterfully through its groundbreaking legal-to-code translation engine, converting statutes into precise, actionable 'Machine Law'... With Rob Taylor's exceptional blend of jurisprudential depth and programming acumen at the helm... solutions of this caliber shift from desirable to downright essential.",
                                                     rating: 5,
                                                     avatar: "G",
                                                     avatarGradient: "linear-gradient(135deg, #1DA1F2, #14171A)",
                                                 },
                                             ],
                                             currentTestimonialIndex, // Active testimonial index
                                             isCarouselPaused, // Carousel pause state
                                             onNextTestimonial, // Next testimonial handler
                                             onPrevTestimonial, // Previous testimonial handler
                                             onGoToTestimonial, // Direct navigation handler
                                             onToggleCarouselPause, // Pause toggle handler

                                             // Podcast event handlers
                                             onPodcastPlay, // Play event handler
                                             onPodcastPause, // Pause event handler
                                             onPodcastComplete, // Completion event handler
                                             onPodcastDownload, // Download event handler

                                             // Animation props
                                             mousePosition: _mousePosition, // Mouse position (retired with cursor trails)
                                             typewriterPhrases, // Array of phrases for typewriter
                                             animationConfig, // Animation configuration object

                                             // Canvas refs retired in the 2026-06 facelift (ambient CSS backdrop replaced them)
                                             threeSceneRef: _threeSceneRef,
                                             particlesRef: _particlesRef,
                                             neuralCanvasRef: _neuralCanvasRef,
                                             matrixCanvasRef: _matrixCanvasRef,

                                             // Navigation handler
                                             onBookDemoNavigate, // Demo booking navigation

                                             // AI booking assistant handler
                                             onAIBookingAssist, // AI assistant for booking

                                             // Visibility tracking
                                             visibleSections = new Set(), // Set of visible section IDs
                                             scrollProgress: _scrollProgress, // Scroll progress percentage

                                             // UI customization
                                             className, // Additional CSS classes

                                             // POC modal state and handlers
                                             isPocModalOpen = false, // POC modal visibility state
                                             onOpenPocModal = () => {}, // Open POC modal handler
                                             onClosePocModal = () => {}, // Close POC modal handler
                                         }) => {
    // VI. DECLARATIONS
    // Reference to typewriter text element
    const typewriterRef = useRef<HTMLSpanElement>(null);
    // Execute VariableDeclaration operation
    // Reference to demo video section for smooth scrolling
    const demoVideoRef = useRef<HTMLDivElement>(null);
    // Execute VariableDeclaration operation
    // Current phrase index in typewriter
    const currentPhraseIndex = useRef(0);
    // Execute VariableDeclaration operation
    // Current character index being typed
    const currentCharIndex = useRef(0);
    // Execute VariableDeclaration operation
    // Flag for delete animation phase
    const isDeleting = useRef(false);
    // Execute VariableDeclaration operation
    // Setter for visible sections (getter unused)
    const [, setVisibleSections] = useState(new Set());
    // Execute VariableDeclaration operation
    // Transmutation decision state for demo
    const [arbiterDecision, setArbiterDecision] = useState("allow"); // Legacy variable name - now represents transmutation success/failure

    // Record player state - moved these to just manage local needle position
    // Track active section for visual effects
    const [activeSection, setActiveSection] = useState<string | null>(null);
    
    const [showComingSoon, setShowComingSoon] = useState(false);
    const [showContactModal, setShowContactModal] = useState(false);

    // Output showcase tab state: which deliverable preview is active
    const [activeOutputTab, setActiveOutputTab] = useState<"redline" | "comment" | "email">("redline");

    // Promotional banner state - dismissible with 24-hour localStorage persistence
    const [showPromoBanner, setShowPromoBanner] = useState(() => {
        if (typeof window !== 'undefined') {
            const dismissed = localStorage.getItem('bitsbound_promo_banner_dismissed_v2');
            if (dismissed) {
                const dismissedAt = parseInt(dismissed, 10);
                const oneDayMs = 24 * 60 * 60 * 1000;
                // Show banner if more than 24 hours have passed
                return Date.now() - dismissedAt > oneDayMs;
            }
        }
        return true; // Show by default
    });

    const handleDismissPromoBanner = () => {
        setShowPromoBanner(false);
        if (typeof window !== 'undefined') {
            localStorage.setItem('bitsbound_promo_banner_dismissed_v2', Date.now().toString());
        }
    };

    // VII. DEPENDENT CONSTANTS
    // Value proposition content structure
    // BitsBound v2: Contract Analysis Robot - Three-Brain Pipeline
    const valueProposition = {
        sections: [ // Array of text sections
            {
                text: // Main proposition text
                    "Upload any contract. Accelerate your first draft from days to ~25-45 minutes: " +
                    "AI-generated redlines, a draft negotiation email, and a risk dashboard—all ready for attorney review.",
                highlight: "gold", // Highlight color
            },
        ],
        quotes: [], // Array of quotes (empty)
        emphasis: { // Emphasized terms
            threeBrainPipeline: "Three-Brain Pipeline", // Key term 1
            bitsbound: "BitsBound", // Key term 2
        },
        additionalSections: [], // Extra sections (empty)
        choiceBox: { // Choice UI component
            title: "", // Choice title (empty)
            options: [], // Choice options (empty)
            conclusion: "", // Choice conclusion (empty)
        },
        additionalBrandStatements: [], // Brand statements (empty)
        finalStatements: [], // Final statements (empty)
    };
    // Market statistics - BitsBound v2 Contract Automation
    // Key market metrics for contract automation buyers
    const marketStats = [
        {
            value: "2 Modes", // Redline + Draft
            label: "Redline Counterparty Paper\nOR Draft Your Own", // Dual capability
        },
        {
            value: "$30/M", // Token-based pricing
            label: "Per Million\nCredits", // Clear billing unit
        },
        {
            value: "25-45 min", // Time to output (Redline ~25, Draft ~45)
            label: "Partner-Level Output\nFully Automated", // Speed advantage
        },
        {
            value: "150+", // Number of analyzers across 9 verticals
            label: "Parallel AI Analyzers\nIn The Swarm", // Technical depth
        },
    ];

    // Advantage features - BitsBound v2 Three-Brain Pipeline
    // Core product advantages for contract analysis - attorney-tool framing
    const advantageFeatures = [
        {
            icon: "🧠", // Brain emoji
            title: "150+ Parallel Analyzers", // Feature title
            description: // Feature description
                "150+ specialized Haiku analyzers across 9 contract verticals examine every domain in parallel: parties, definitions, IP, SLA, DPA, AI terms, commercial terms, liability, indemnification, economic exposure, research, and more. Your first-draft foundation in minutes.",
            highlights: [ // Key points
                "150+ specialized AI analyzers", // Technical feature
                "Comprehensive contract coverage", // Coverage
                "Risk heatmaps for attorney review", // Outputs
            ],
        },
        {
            icon: "⚡", // Lightning for dynamic scaling
            title: "Instant Swarm™ (Dynamic Agent Scaling)", // Feature title
            description: // Feature description
                "Opus 4.5 intelligently spawns parallel SAC agents based on contract quality and complexity. Worse contracts get more agents. Larger contracts get more agents. Your aggressiveness setting amplifies both. Each agent has discretionary authority to edit ANY clause affecting their section's protections.",
            highlights: [ // Key points
                "Risk-proportional agent allocation", // Intelligence
                "Priority scoring for high-risk sections", // Prioritization
                "Cross-section discretionary authority", // Power
            ],
        },
        {
            icon: "🔴", // Red circle for redlining
            title: "Swarm-Powered Redlines", // Feature title - Redline Mode
            description: // Feature description
                "Upload counterparty's contract and autonomous agents attack every clause. Get partner-level redlines with real Track Changes, a draft negotiation email, and a risk dashboard—all ready for attorney review in ~45 minutes.",
            highlights: [ // Key points
                "Real OOXML Track Changes (w:ins/w:del)", // Technical
                "Draft negotiation email included", // Deliverable
                "Risk dashboard with clause citations", // Analytics
            ],
        },
        {
            icon: "✍️", // Writing hand for drafting
            title: "Multi-Pass Drafting", // Feature title - Draft Mode
            description: // Feature description
                "Don't just respond to counterparty paper—control the negotiation by drafting first. Select a vertical (SaaS, M&A, NDA, etc.), set your aggressiveness level, and BitsBound generates a complete contract from our battle-tested templates optimized for YOUR position.",
            highlights: [ // Key points
                "9 contract verticals supported", // Coverage
                "Templates optimized for maximum protection", // Quality
                "Same pipeline—now for paper you control", // Architecture
            ],
        },
        {
            icon: "⚖️", // Scales emoji
            title: "Brain A ↔ Brain B Ping-Pong", // Feature title
            description: // Feature description
                "SAC drafts redlines with full context. Autopilot enforces YOUR playbook rules. They volley sentence-by-sentence until consensus—giving you a solid starting point to refine.",
            highlights: [ // Key points
                "Upload your own playbooks", // Customization
                "Firm-specific policy enforcement", // Policy
                "Draft quality you can build on", // Quality
            ],
        },
        {
            icon: "📝", // Document emoji
            title: "Real Track Changes + Comments", // Feature title
            description: // Feature description
                "The Executor performs precision OOXML surgery on your original .docx. Real w:ins, w:del elements for draft redlines PLUS w:comment margin notes. Review and refine in Word's Review pane.",
            highlights: [ // Key points
                "Real Word Track Changes (w:ins/w:del)", // Core feature
                "Margin comments for context", // Comments emphasis
                "Ready for attorney review and refinement", // Quality
            ],
        },
        {
            icon: "✉️", // Email emoji
            title: "Draft Negotiation Email", // Feature title
            description: // Feature description
                "Draft email explaining each requested change with professional rationale. Review, refine with your judgment, personalize, and send to counterparty.",
            highlights: [ // Key points
                "Professional starting point", // Output
                "Change-by-change explanation", // Detail
                "Ready for your final review", // Quality
            ],
        },
        {
            icon: "⚡", // Lightning for speed
            title: "Claude Code & Desktop Integration", // Feature title
            description: // Feature description
                "Analyze contracts directly from Claude Code or Claude Desktop. Install via plugin (/install-plugin BitsBound/bitsbound-mcp-server) or npm (@bitsbound/mcp-server). Just say 'analyze this contract' and Claude handles everything—uploading, analysis, and delivering your redlined DOCX.",
            highlights: [ // Key points
                "One-command plugin install", // Ease
                "Reads local files directly", // Convenience
                "Natural language interface", // UX
            ],
        },
        {
            icon: "🌐", // Globe emoji for API
            title: "REST API for Developers", // Feature title
            description: // Feature description
                "Integrate BitsBound's contract intelligence into your applications with our production-ready REST API. OpenAPI spec included—import into Postman or generate client SDKs. Same token-based billing as the web interface.",
            highlights: [ // Key points
                "OpenAPI spec at /v1/openapi.json", // Developer-friendly
                "x-api-key authentication", // Security
                "Programmatic contract analysis", // Use case
            ],
        },
    ];

    // Metrics data - BitsBound v2 Contract Analysis Robot
    // Key performance metrics for contract analysis - attorney-tool framing
    const metricsData = [
        {
            icon: "🤖", // Robot emoji
            value: "150+", // AI analyzers across 9 verticals
            label: "Specialized AI Analyzers", // Metric label
            description: // Metric description
                "150+ parallel AI analyzers across 9 contract verticals examine every aspect of your contract: parties, IP, SLA, DPA, AI terms, commercial terms, liability, indemnification, economic exposure, research, and more—all flagged for your review.",
        },
        {
            icon: "🎯", // Target emoji
            value: "3", // Outputs
            label: "Draft Deliverables", // Metric label
            description: // Metric description
                "Draft redlined Word document with Track Changes, draft negotiation email, and analytical dashboard—all ready for attorney review and refinement.",
        },
        {
            icon: "🤖", // Robot emoji
            value: "Opus + Sonnet + Haiku", // Model strategy
            label: "Tiered Model Strategy", // Metric label
            description: // Metric description
                "Right model for each task: Opus for precision draft redlines, Sonnet for SAC orchestration (1M context), Haiku for fast parallel analysis.",
        },
    ];

    // VIII. OPERATIONS
    // Navigation click handler factory function
    const handleNavClick = (sectionId: string) => (event: React.MouseEvent<HTMLAnchorElement>) => {
        // Execute ExpressionStatement operation
        // Prevent default link behavior
        event.preventDefault();
        // Execute VariableDeclaration operation
        // Get target section element
        const element = document.getElementById(sectionId);
        // Execute IfStatement operation
        // Check if element exists
        if (element) {
            // Execute ExpressionStatement operation
            // Smooth scroll to section
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    // Legacy comment - now toggles transmutation decision for demo effect
    // Auto-toggle transmutation decision visualization
    useEffect(() => {
        // Execute VariableDeclaration operation
        // Set up interval for decision toggle
        const interval = setInterval(() => {
            // Execute ExpressionStatement operation
            // Toggle between allow and shutdown states
            setArbiterDecision((prev) => (prev === "allow" ? "shutdown" : "allow"));
        }, 4000); // Switch every 4 seconds

        // Execute ReturnStatement operation
        // Cleanup interval on unmount
        return () => clearInterval(interval);
    }, []);

    // Track active section based on scroll position
    // Monitor scroll to update active section
    useEffect(() => {
        // Execute VariableDeclaration operation
        // Scroll handler function
        const handleScroll = () => {
            // Execute VariableDeclaration operation
            // Get all section IDs as array
            const sections = Object.values(SECTION_IDS);
            // Execute VariableDeclaration operation
            // Calculate middle of viewport
            const scrollPosition = window.scrollY + window.innerHeight / 2;

            // Execute VariableDeclaration operation
            // Initialize current section tracker
            let currentSection = null;

            // Loop through all sections
            for (      // Execute VariableDeclaration operation
                const sectionId of sections) {
                // Execute VariableDeclaration operation
                // Get section element by ID
                const element = document.getElementById(sectionId);
                // Execute IfStatement operation
                // Check if element exists
                if (element) {
                    // Execute VariableDeclaration operation
                    // Get element position and size
                    const rect = element.getBoundingClientRect();
                    // Execute VariableDeclaration operation
                    // Calculate absolute top position
                    const top = rect.top + window.scrollY;
                    // Execute VariableDeclaration operation
                    // Calculate absolute bottom position
                    const bottom = top + rect.height;

                    // Execute IfStatement operation
                    // Check if scroll position is within section
                    if (scrollPosition >= top && scrollPosition < bottom) {
                        // Execute ExpressionStatement operation
                        // Set current section
                        currentSection = sectionId;
                        break; // Exit loop when found
                    }
                }
            }

            // Execute ExpressionStatement operation
            // Update active section state
            setActiveSection(currentSection);
        };

        // Execute ExpressionStatement operation
        // Add scroll event listener with passive: true for better mobile performance
        window.addEventListener("scroll", handleScroll, { passive: true });
        // Execute ExpressionStatement operation
        // Run initial check on mount
        handleScroll(); // Initial check

        // Execute ReturnStatement operation
        // Cleanup scroll listener on unmount
        return () => window.removeEventListener("scroll", handleScroll);
    }, []); // Empty deps, run once

    // Execute VariableDeclaration operation
    // Handler for discover vision button
    const _handleDiscoverVision = (event: React.MouseEvent<HTMLAnchorElement>) => {
        // Execute ExpressionStatement operation
        // Prevent default action
        event.preventDefault();
        // Execute ExpressionStatement operation
        // Navigate to value proposition section
        handleNavClick(SECTION_IDS.VALUE_PROPOSITION)(event);
    };

    // Execute VariableDeclaration operation
    // Handler for try demo button - Downloads BUBSA baseline agreement PDF
    const handleTryDemo = (event: React.MouseEvent<HTMLAnchorElement>) => {
        // Execute ExpressionStatement operation
        // Prevent default action
        event.preventDefault();

        // Execute ExpressionStatement operation
        // Generate BUBSA baseline agreement PDF content
        const pdfContent = `BitsBound Universal Baseline SaaS Agreement (BUBSA) v1.0

THE BASELINE STANDARD FOR B2B SAAS AGREEMENTS

Generated: ${new Date().toLocaleString()}

This is the BitsBound Universal Baseline SaaS Agreement (BUBSA) - the open standard for technology services agreements. Review the baseline agreement as a traditional contract (PDF), or configure your own terms through our visual interface to create a living agreement that executes automatically through your existing systems.

Features:
- 24 comprehensive sections covering all SaaS agreement provisions
- Party definitions, IP licensing, payment terms, SLA monitoring
- Data privacy (GDPR), confidentiality, indemnification
- Termination, renewal, and dispute resolution clauses
- 100% Free • No Registration Required • Open Standard

Next Steps:
1. Review this baseline agreement PDF
2. Visit BitsBound to configure your custom terms
3. Both parties negotiate through shared interface
4. Agreement becomes live and self-executing

Learn more at: https://bitsbound.com

This is a preview. Full PDF generation with complete legal text coming soon.`;

        // Execute ExpressionStatement operation
        // Create blob with PDF content
        const blob = new Blob([pdfContent], { type: 'text/plain' });

        // Execute ExpressionStatement operation
        // Create download URL
        const url = URL.createObjectURL(blob);

        // Execute ExpressionStatement operation
        // Create temporary link element for download
        const link = document.createElement('a');
        link.href = url;
        link.download = `BUBSA-Baseline-Agreement-${new Date().toISOString().split('T')[0]}.txt`;

        // Execute ExpressionStatement operation
        // Trigger download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Execute ExpressionStatement operation
        // Clean up URL
        URL.revokeObjectURL(url);
    };

    // Execute VariableDeclaration operation
    // Handler for schedule call button
    const handleScheduleCall = (event: React.MouseEvent<HTMLAnchorElement>) => {
        // Execute ExpressionStatement operation
        // Prevent default action
        event.preventDefault();
        // Execute ExpressionStatement operation
        // Show coming soon modal instead of navigating
        setShowComingSoon(true);
        // Auto-hide after 3 seconds
        setTimeout(() => setShowComingSoon(false), 3000);
    };

    // Execute VariableDeclaration operation
    // Handler for free trial button
    const handleFreeTrialClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        // Execute ExpressionStatement operation
        // Prevent default action
        event.preventDefault();
        // Execute ExpressionStatement operation
        // Navigate to trial page
        window.location.href = "/trial";
    };

    // Execute VariableDeclaration operation
    // Handler for book demo button (unused)
    const _handleBookDemoClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        // Execute ExpressionStatement operation
        // Prevent default action
        event.preventDefault();
        // Execute ExpressionStatement operation
        // Navigate to demo page
        window.location.href = "/demo";
    };

    // Record player drag and drop handlers

    // IX. PRE-RENDER LOGIC
    // Typewriter effect
    // Animated typewriter text effect
    useEffect(() => {
        // Execute IfStatement operation
        // Check if typewriter requirements met
        if (
            !typewriterRef.current || // No ref element
            !typewriterPhrases || // No phrases provided
            typewriterPhrases.length === 0 // Empty phrases array
        ) {
            // Execute ReturnStatement operation
            // Exit if requirements not met
            // Silently exit if conditions not met
            return;
        }
        // Typewriter effect starting

        // Execute VariableDeclaration operation
        // Get typewriter DOM element
        const typewriterElement = typewriterRef.current;
        // Execute VariableDeclaration operation
        // Timeout variable for animation
        let timeout: ReturnType<typeof setTimeout> | undefined;

        // Execute VariableDeclaration operation
        const type = () => {
            // Execute VariableDeclaration operation
            const currentPhrase = typewriterPhrases[currentPhraseIndex.current];
            // Continue typing animation

            // Execute IfStatement operation
            if (isDeleting.current) {
                // Execute ExpressionStatement operation
                currentCharIndex.current--;
                // Execute ExpressionStatement operation
                typewriterElement.textContent = currentPhrase.substring(
                    0,
                    currentCharIndex.current,
                );

                // Execute IfStatement operation
                if (currentCharIndex.current === 0) {
                    // Execute ExpressionStatement operation
                    isDeleting.current = false;
                    // Execute ExpressionStatement operation
                    currentPhraseIndex.current =
                        (currentPhraseIndex.current + 1) % typewriterPhrases.length;
                    // Execute ExpressionStatement operation
                    timeout = setTimeout(type, 500);
                } else {
                    // Execute ExpressionStatement operation
                    timeout = setTimeout(
                        type,
                        animationConfig?.TYPEWRITER_BACK_SPEED || 25,
                    );
                }
            } else {
                // Execute ExpressionStatement operation
                currentCharIndex.current++;
                // Execute ExpressionStatement operation
                typewriterElement.textContent = currentPhrase.substring(
                    0,
                    currentCharIndex.current,
                );

                // Execute IfStatement operation
                if (currentCharIndex.current === currentPhrase.length) {
                    // Execute ExpressionStatement operation
                    isDeleting.current = true;
                    // Execute ExpressionStatement operation
                    timeout = setTimeout(
                        type,
                        animationConfig?.TYPEWRITER_BACK_DELAY || 3000,
                    );
                } else {
                    // Execute ExpressionStatement operation
                    timeout = setTimeout(type, animationConfig?.TYPEWRITER_SPEED || 40);
                }
            }
        };

        // Execute ExpressionStatement operation
        // Start typing animation
        type();

        // Execute ReturnStatement operation
        return () => {
            // Execute IfStatement operation
            if (timeout) {
                // Execute ExpressionStatement operation
                clearTimeout(timeout);
            }
        };
    }, [typewriterPhrases, animationConfig]);

    // Scroll fade-in animation observer
    useEffect(() => {
        // Execute VariableDeclaration operation
        const observerOptions = {
            threshold: 0.1,
            rootMargin: "0px 0px -100px 0px",
        };

        // Execute VariableDeclaration operation
        const observer = new IntersectionObserver((entries) => {
            // Execute ExpressionStatement operation
            entries.forEach((entry) => {
                // Execute IfStatement operation
                if (entry.isIntersecting) {
                    // Execute ExpressionStatement operation
                    entry.target.classList.add(styles.visible);
                    // Execute ExpressionStatement operation
                    setVisibleSections((prev) => new Set([...prev, entry.target.id]));
                }
            });
        }, observerOptions);

        // Execute VariableDeclaration operation
        const fadeElements = document.querySelectorAll(`.${styles.fadeInView}`);
        // Execute ExpressionStatement operation
        fadeElements.forEach((el) => observer.observe(el));

        // Execute ReturnStatement operation
        return () => {
            // Execute ExpressionStatement operation
            fadeElements.forEach((el) => observer.unobserve(el));
        };
    }, []);

    // Timeline ball drop animation observer
    useEffect(() => {
        // Execute VariableDeclaration operation
        const timelineSection = document.getElementById(SECTION_IDS.TIMELINE);
        // Execute VariableDeclaration operation
        const timelineContainer = document.querySelector(
            "[data-timeline-container]",
        );

        // Execute IfStatement operation
        if (!timelineSection || !timelineContainer) {
            // Execute ReturnStatement operation
            return;
        }

        // Execute VariableDeclaration operation
        const timelineObserver = new IntersectionObserver(
            (entries) => {
                // Execute ExpressionStatement operation
                entries.forEach((entry) => {
                    // Execute IfStatement operation
                    if (entry.isIntersecting) {
                        // Add class to trigger ball drop animation
                        timelineContainer.classList.add(styles.timelineActive);
                        // Disconnect after triggering to prevent re-triggering
                        timelineObserver.disconnect();
                    }
                });
            },
            {
                threshold: 0.2, // Trigger when 20% of section is visible
                rootMargin: "0px",
            },
        );

        // Execute ExpressionStatement operation
        timelineObserver.observe(timelineSection);

        // Execute ReturnStatement operation
        return () => timelineObserver.disconnect();
    }, []);

    // Cursor trail effect retired in the 2026-06 facelift (gimmick removed for the premium look)

    // X. RENDER/RETURN
    // Skip the problematic shared header component entirely to avoid React context issues
    // The header was causing production crashes due to hooks being called outside React context
    
    return (
        <>
            {/* Coming Soon Modal */}
            {showComingSoon && (
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    background: 'linear-gradient(135deg, rgba(32, 178, 170, 0.95), rgba(138, 43, 226, 0.95))',
                    backdropFilter: 'blur(20px)',
                    border: '2px solid rgba(255, 255, 255, 0.3)',
                    borderRadius: '20px',
                    padding: '40px',
                    zIndex: 10000,
                    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.4)',
                    textAlign: 'center',
                    animation: 'fadeIn 0.3s ease-out'
                }}>
                    <h2 style={{
                        color: '#ffffff',
                        fontSize: '32px',
                        fontWeight: 'bold',
                        marginBottom: '20px',
                        textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
                    }}>
                        Get in Touch
                    </h2>
                    <p style={{
                        color: '#ffffff',
                        fontSize: '18px',
                        lineHeight: '1.6',
                        maxWidth: '400px',
                        opacity: 0.95
                    }}>
                        Want a walkthrough, enterprise pricing, or a pilot? Email the founder directly and you will hear back within one business day.
                    </p>
                    <a
                        href="mailto:admin@bitsbound.com?subject=BitsBound%20Platform%20Launch%20Interest&body=Hi%20BitsBound%20Team%2C%0A%0AI'm%20interested%20in%20being%20notified%20when%20the%20platform%20launches.%0A%0AName%3A%20%0ACompany%3A%20%0ARole%3A%20%0A%0AThank%20you!"
                        style={{
                            display: 'inline-block',
                            marginTop: '25px',
                            padding: '12px 28px',
                            background: 'rgba(255, 255, 255, 0.2)',
                            border: '2px solid rgba(255, 255, 255, 0.5)',
                            borderRadius: '10px',
                            color: '#ffffff',
                            fontSize: '16px',
                            fontWeight: 600,
                            textDecoration: 'none',
                            transition: 'all 0.3s ease',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)';
                            e.currentTarget.style.transform = 'scale(1.05)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                    >
                        Email admin@bitsbound.com
                    </a>
                </div>
            )}

            {/* Backdrop for Coming Soon modal */}
            {showComingSoon && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(0, 0, 0, 0.7)',
                        zIndex: 9999,
                        cursor: 'pointer'
                    }}
                    onClick={() => setShowComingSoon(false)}
                />
            )}

            {/* Contact Us Modal */}
            {showContactModal && (
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    background: 'linear-gradient(135deg, rgba(32, 178, 170, 0.98), rgba(20, 120, 115, 0.98))',
                    backdropFilter: 'blur(20px)',
                    border: '2px solid rgba(255, 255, 255, 0.3)',
                    borderRadius: '20px',
                    padding: '40px',
                    zIndex: 10000,
                    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.4)',
                    textAlign: 'center',
                    animation: 'fadeIn 0.3s ease-out',
                    minWidth: '320px'
                }}>
                    <h2 style={{
                        color: '#ffffff',
                        fontSize: '28px',
                        fontWeight: 'bold',
                        marginBottom: '16px',
                        textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
                    }}>
                        Contact Us
                    </h2>
                    <p style={{
                        color: '#ffffff',
                        fontSize: '16px',
                        lineHeight: '1.6',
                        maxWidth: '400px',
                        opacity: 0.95,
                        marginBottom: '24px'
                    }}>
                        Have questions about BitsBound's AI contract analysis?
                        We'd love to hear from you.
                    </p>
                    <a
                        href="mailto:admin@bitsbound.com?subject=BitsBound%20Contract%20Analysis%20Inquiry"
                        style={{
                            display: 'inline-block',
                            background: 'rgba(255, 255, 255, 0.15)',
                            border: '2px solid rgba(255, 255, 255, 0.4)',
                            borderRadius: '12px',
                            padding: '16px 32px',
                            color: '#ffffff',
                            fontSize: '20px',
                            fontWeight: 'bold',
                            textDecoration: 'none',
                            transition: 'all 0.2s ease',
                            letterSpacing: '0.5px'
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.25)';
                            e.currentTarget.style.transform = 'scale(1.02)';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                    >
                        admin@bitsbound.com
                    </a>
                    <button
                        onClick={() => setShowContactModal(false)}
                        style={{
                            position: 'absolute',
                            top: '12px',
                            right: '12px',
                            background: 'rgba(255, 255, 255, 0.2)',
                            border: 'none',
                            borderRadius: '50%',
                            width: '32px',
                            height: '32px',
                            color: '#ffffff',
                            fontSize: '18px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'background 0.2s ease'
                        }}
                        onMouseOver={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.35)'}
                        onMouseOut={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)'}
                    >
                        ✕
                    </button>
                </div>
            )}

            {/* Backdrop for Contact Us modal */}
            {showContactModal && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(0, 0, 0, 0.7)',
                        zIndex: 9999,
                        cursor: 'pointer'
                    }}
                    onClick={() => setShowContactModal(false)}
                />
            )}

            {/* T_UNIFIED_HEADER_2026_01_04: Banner and nav combined into one header element */}
            <header className={styles.simpleHeader} style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 1000,
                display: 'flex',
                flexDirection: 'column',
                padding: 0,
                overflow: 'visible',
                background: 'transparent',
            }}>
                {/* Promotional Banner - Now inside header */}
                {showPromoBanner && (
                    <a
                        href={`${AUTH_BASE_URL}/auth/register`}
                        style={{
                            position: 'relative',
                            width: '100%',
                            height: '36px',
                            background: 'linear-gradient(90deg, rgba(13, 38, 36, 0.98) 0%, rgba(16, 56, 53, 0.98) 50%, rgba(13, 38, 36, 0.98) 100%)',
                            borderBottom: '1px solid rgba(32, 178, 170, 0.35)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '0 40px',
                            textDecoration: 'none',
                            cursor: 'pointer',
                        }}
                    >
                        <span style={{
                            color: '#ffffff',
                            fontSize: 'clamp(11px, 2.5vw, 14px)',
                            fontWeight: 500,
                            textAlign: 'center',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}>
                            Your first contract is free, no credit card required. <span style={{ color: '#2dd4bf', fontWeight: 600 }}>Start now →</span>
                        </span>
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleDismissPromoBanner();
                            }}
                            style={{
                                position: 'absolute',
                                right: '8px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'rgba(255, 255, 255, 0.2)',
                                border: 'none',
                                borderRadius: '50%',
                                width: '20px',
                                height: '20px',
                                color: '#ffffff',
                                fontSize: '12px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                            aria-label="Dismiss promotional banner"
                        >
                            ✕
                        </button>
                    </a>
                )}
                {/* Navigation bar */}
                <div style={{
                    width: '100%',
                    height: 'clamp(60px, 10vw, 80px)',
                    background: 'rgba(0, 0, 0, 0.95)',
                    backdropFilter: 'blur(10px)',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '0 clamp(0.75rem, 3vw, 2rem)',
                }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    maxWidth: '1280px',
                    margin: '0 auto'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 'clamp(0.25rem, 1vw, 0.5rem)' }}>
                        {/* BitsBound BB Logo SVG */}
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            viewBox="0 0 916 872"
                            role="img"
                            aria-label="BitsBound Logo"
                            style={{ width: 'clamp(28px, 6vw, 40px)', height: 'clamp(28px, 6vw, 40px)' }}
                        >
                            <path
                                d="M0 0 C26.29745068 -0.12760035 52.58183841 0.03615052 78.875 0.5 C79.55309219 0.51195782 80.23118439 0.52391563 80.92982483 0.53623581 C89.2866748 0.6842093 97.64339417 0.83882014 106 1 C104.99865791 85.90088167 103.98332029 170.80153897 102.06449127 305.58102417 C102.00989267 309.32015737 101.95549124 313.0592934 101.90114415 316.79843026 C101.61801643 336.27488329 101.32908312 355.7512404 101.03319991 375.22750384 C100.95946374 380.0896906 100.88723374 384.9518982 100.81567383 389.81411743 C100.72041213 396.28296603 100.62156448 402.75175404 100.52035713 409.22051239 C100.48421394 411.56169726 100.44912895 413.90289878 100.41526604 416.24411774 C100.19827284 431.17796588 99.73573428 446.08240794 99 461 C99.66 461 100.32 461 101 461 C101.2693335 460.40848145 101.53866699 459.81696289 101.81616211 459.20751953 C102.99867532 457.00247015 104.22062222 455.48358441 105.94140625 453.6796875 C106.52019531 453.06738281 107.09898437 452.45507812 107.6953125 451.82421875 C108.31148438 451.18097656 108.92765625 450.53773438 109.5625 449.875 C110.84573922 448.51887904 112.12829229 447.16210848 113.41015625 445.8046875 C114.03164551 445.14823242 114.65313477 444.49177734 115.29345703 443.81542969 C117.39893814 441.57560744 119.45559179 439.29561148 121.5 437 C125.82096085 432.16310352 130.24691669 427.42813485 134.68945312 422.703125 C135.24568359 422.11015625 135.80191406 421.5171875 136.375 420.90625 C136.94003738 420.33101593 137.50507477 419.75578186 138.0872345 419.16311646 C140.07665818 417.0454093 140.07665818 417.0454093 141.51457214 414.48019409 C144.09870036 410.64170609 146.5851598 407.6491241 151.21011734 406.40590668 C158.09222483 405.39429204 165.04932671 405.54809462 171.98828125 405.6015625 C174.25597123 405.58973213 176.5236487 405.57523343 178.79130554 405.55819702 C183.53690817 405.53447728 188.28063256 405.54777367 193.02612305 405.58642578 C199.08351982 405.63214122 205.1352941 405.57871001 211.19213581 405.49630165 C215.87419685 405.44493297 220.55493181 405.45036175 225.23717308 405.47208786 C227.46854947 405.47504529 229.70003159 405.45986563 231.93114662 405.4255867 C251.1376453 405.17842521 251.1376453 405.17842521 257.70939159 411.21327782 C260.02598117 413.68364373 262.01166384 416.2551232 264 419 C265.11199499 420.28222834 266.23328758 421.5566596 267.375 422.8125 C267.9009375 423.42996094 268.426875 424.04742188 268.96875 424.68359375 C271.86294857 427.98409327 274.87199787 431.173612 277.875 434.375 C281.78887343 438.54990049 285.68811123 442.73125565 289.5 447 C293.27344174 451.22400194 297.12835466 455.3663213 301 459.5 C310.62359652 469.77699546 310.62359652 469.77699546 314.62484741 474.45019531 C316.9483052 477.07106834 316.9483052 477.07106834 319.77603149 479.20727539 C326.00985773 484.61024381 328.59689215 488.99435706 329.29118919 497.30137634 C329.52826203 502.95548397 329.52104567 508.59223121 329.4609375 514.25 C329.46835925 516.71518102 329.47904483 519.18035416 329.49282837 521.64550781 C329.50899134 526.79700826 329.48565816 531.946402 329.43408203 537.09765625 C329.37140127 543.67587974 329.40751751 550.24916682 329.47337914 556.82720947 C329.51327685 561.91329634 329.50041172 566.99822743 329.47197342 572.08435059 C329.4646759 574.50826616 329.47349815 576.93228933 329.4992485 579.3560791 C329.67225028 600.21350834 329.67225028 600.21350834 324.22826576 606.7098999 C321.96806823 608.99667599 319.50525132 610.98848705 317 613 C315.1181971 614.92555342 313.34818638 616.9201876 311.5625 618.9375 C307.21449707 623.68335038 302.85068257 628.4144366 298.48291016 633.14208984 C293.30633676 638.74711548 288.15207502 644.37246312 283 650 C281.18779908 651.97944081 279.37532688 653.95863244 277.5625 655.9375 C276.88888428 656.67299072 276.88888428 656.67299072 276.20166016 657.42333984 C273.78124488 660.06402754 271.35523781 662.69936041 268.921875 665.328125 C268.14348267 666.16935913 268.14348267 666.16935913 267.34936523 667.02758789 C266.37051348 668.08480998 265.3909366 669.14136148 264.41040039 670.19702148 C263.95141357 670.69274658 263.49242676 671.18847168 263.01953125 671.69921875 C262.3142907 672.41941444 262.3142907 672.41941444 261.59480286 673.15415955 C259.9164056 674.96731129 259.9164056 674.96731129 258.76358032 677.24783325 C256.44381074 680.89437366 254.17059968 683.46522599 249.83570671 684.53322029 C242.92922483 685.44559976 235.95602062 685.28598833 229.00390625 685.23046875 C226.72760461 685.23907852 224.45131124 685.25021096 222.17503357 685.26374817 C217.4109803 685.28150032 212.64844545 685.26630897 207.88452148 685.22827148 C201.79264692 685.18260937 195.70485721 685.22248441 189.6132822 685.28762341 C184.91427308 685.3277468 180.21623054 685.32044487 175.51713371 685.29921913 C173.27214189 685.29507772 171.0270684 685.30594686 168.78222847 685.33238792 C151.27765765 685.5009418 151.27765765 685.5009418 145.69869995 681.82449341 C143.42566918 679.32256144 141.73016375 676.89216366 140 674 C138.82360282 672.66899282 137.62015432 671.36066798 136.375 670.09375 C135.8186084 669.50062012 135.2622168 668.90749023 134.68896484 668.29638672 C134.13160645 667.7035791 133.57424805 667.11077148 133 666.5 C128.37086457 661.55887149 123.79223953 656.58086514 119.28125 651.53125 C116.03179339 647.92568856 112.73087727 644.36821094 109.42333984 640.81591797 C105.52396258 636.61321146 101.78074297 632.32084911 98 628 C97.34 645.49 96.68 662.98 96 681 C79.93419359 681.04010881 79.93419359 681.04010881 72.82617188 681.04882812 C68.06663837 681.0546953 63.3071249 681.06145014 58.54760742 681.07543945 C54.68955082 681.08670178 50.83151581 681.09236312 46.97344398 681.09487724 C45.53704807 681.09665691 44.10065264 681.10011729 42.66426659 681.10573006 C25.43644076 681.17006146 8.21740146 680.53292379 -9 680 C-8.08297994 596.66471942 -7.16121562 513.32952021 -6.00008392 429.9972229 C-5.94849321 426.29385081 -5.89728441 422.59047356 -5.84620088 418.88709444 C-5.47183228 391.75650102 -5.08110063 364.62658451 -4.56322098 337.49827766 C-3.93243854 304.42627431 -3.54379245 271.35212811 -3.15379912 238.27660418 C-2.96550047 222.32621492 -2.77110698 206.37589817 -2.5762682 190.42558765 C-2.55406173 188.6074491 -2.53187229 186.78931034 -2.50969982 184.97117138 C-2.01895968 144.7363691 -1.47376826 104.50238303 -0.90862036 64.26856375 C-0.8748983 61.86775967 -0.84120377 59.4669552 -0.80751419 57.06615067 C-0.54052546 38.04406935 -0.2715893 19.02201624 0 0 Z"
                                fill="#ffffff"
                                transform="translate(119,92)"
                            />
                            <path
                                d="M0 0 C25.94340983 -0.12164729 51.87329464 0.04297591 77.8125 0.5 C78.83092232 0.51793673 78.83092232 0.51793673 79.86991882 0.53623581 C88.24673631 0.68436189 96.62339112 0.840546 105 1 C105.08538997 29.57329519 104.87468419 58.13378837 104.45991158 86.70395184 C104.38068999 92.20338287 104.30480892 97.7028603 104.22843933 103.20233154 C104.08151698 113.74423106 103.93141109 124.28608284 103.78019267 134.82792151 C103.6584338 143.32537409 103.53844226 151.82285021 103.41952515 160.32034302 C102.77303293 206.51108208 102.12428021 252.70173415 101.35546875 298.890625 C101.33123925 300.34902187 101.30701209 301.80741878 101.28278732 303.26581573 C101.16920827 310.09888903 101.05507222 316.93195298 100.9407959 323.76501465 C100.90886894 325.67479347 100.90886894 325.67479347 100.876297 327.62315369 C100.83382282 330.16263422 100.79129164 332.70211379 100.748703 335.24159241 C100.05851594 376.49693535 99.71029406 417.73923871 100 459 C101.60033274 457.41153973 103.19896209 455.82136322 104.796875 454.23046875 C105.68729492 453.34512451 106.57771484 452.45978027 107.49511719 451.54760742 C110.08391047 448.91465831 112.49913625 446.1896939 114.8984375 443.38671875 C117.82120804 440.0673641 120.84969612 436.85079503 123.875 433.625 C133.4108148 424.36782039 133.4108148 424.36782039 141.15805054 413.83026123 C143.5066809 410.15870092 145.80859894 407.54957266 150.17554855 406.45440292 C157.11249847 405.51040893 164.12257328 405.63714851 171.109375 405.6640625 C173.40091463 405.64782458 175.69244041 405.62951153 177.98394775 405.60922241 C182.78243289 405.57794769 187.57942518 405.58115952 192.37792969 405.60693359 C198.50391621 405.63577037 204.62408578 405.56489459 210.74917221 405.46598244 C215.4818143 405.40317684 220.2130755 405.40111921 224.94605255 405.41614914 C227.20260279 405.41476966 229.4592404 405.39320557 231.71538544 405.35042191 C250.20500521 405.04472841 250.20500521 405.04472841 255.93664551 409.78973389 C258.56936369 412.41116219 260.73998042 415.24740305 262.81269073 418.32328415 C264.79321328 421.12017427 267.14511496 423.51343327 269.5 426 C270.40807454 426.98790934 271.31454025 427.97730209 272.21875 428.96875 C275.13784695 432.1532194 278.06832137 435.32711625 281 438.5 C287.13702617 445.14260258 293.24768628 451.80911659 299.35449219 458.47949219 C300.71528572 459.96568642 302.07634875 461.45163338 303.4375 462.9375 C303.88512695 463.42637695 304.33275391 463.91525391 304.79394531 464.41894531 C307.23788097 467.08584873 309.68879927 469.7460046 312.1484375 472.3984375 C312.67638916 472.96828369 313.20434082 473.53812988 313.74829102 474.12524414 C314.75284688 475.20882235 315.75845444 476.29142704 316.76538086 477.37280273 C317.67918518 478.35873702 318.58491326 479.35224395 319.48078918 480.35449696 C320.96697765 482.00649923 320.96697765 482.00649923 322.55877686 483.44748211 C326.82109792 487.69155441 327.71497481 490.98709035 327.85760498 496.9309845 C327.85174377 497.94674057 327.84588257 498.96249664 327.83984375 500.0090332 C327.85678284 501.09614594 327.87372192 502.18325867 327.89117432 503.30331421 C327.93785672 506.88628326 327.93996023 510.46753146 327.9375 514.05078125 C327.95170811 516.55031517 327.96710683 519.04984258 327.98364258 521.54936218 C328.01051936 526.78556786 328.01404033 532.02133306 328.00195312 537.25756836 C327.99015025 542.622942 328.01827829 547.98633944 328.08398438 553.35131836 C328.16241891 559.8437023 328.19156794 566.33439098 328.18240356 572.82723045 C328.18578084 575.29473348 328.20501734 577.76226955 328.24069214 580.22951698 C328.50195619 600.53415259 328.50195619 600.53415259 324.80810547 605.66488647 C322.33234718 608.1554499 319.90603288 610.04988099 317 612 C315.18326105 613.87428056 315.18326105 613.87428056 313.75 615.6875 C310.32208353 619.69215123 306.73035928 623.53089721 303.125 627.375 C299.21115988 631.54993311 295.31188986 635.73125443 291.5 640 C287.7265588 644.22400134 283.87166228 648.36633784 280 652.5 C275.38003292 657.43326815 270.80888296 662.40180642 266.3046875 667.44140625 C263.39487331 670.67179319 260.4499709 673.86880179 257.5 677.0625 C256.70601807 677.92222412 256.70601807 677.92222412 255.89599609 678.79931641 C251.0902585 683.99568754 251.0902585 683.99568754 247.07472229 684.18754578 C245.27720335 684.22120541 243.47956775 684.24891027 241.68188477 684.2722168 C240.70293747 684.28842575 239.72399017 684.3046347 238.71537781 684.32133484 C229.65705005 684.4618687 220.59772645 684.53972197 211.53854465 684.60025311 C205.45108479 684.64118861 199.36523775 684.70144813 193.27856445 684.80932617 C187.39631806 684.9132371 181.51550913 684.9676851 175.63239861 684.98771095 C173.39364648 685.00361968 171.1549455 685.03679456 168.91671944 685.08786583 C150.47226685 685.48841082 150.47226685 685.48841082 145.45407104 681.83462524 C142.93537654 679.35032244 140.9676148 676.92926089 139 674 C137.93293193 672.75668687 136.85283582 671.5241992 135.75 670.3125 C134.93015625 669.35537109 134.93015625 669.35537109 134.09375 668.37890625 C131.21302163 665.10583987 128.23129278 661.93137154 125.25 658.75 C119.98565601 653.12940124 114.74411739 647.49067545 109.5546875 641.80078125 C107.81706828 639.89577669 106.07197391 637.99756949 104.3203125 636.10546875 C103.49273438 635.20441406 102.66515625 634.30335938 101.8125 633.375 C100.70841797 632.18003906 100.70841797 632.18003906 99.58203125 630.9609375 C98 629 98 629 98 627 C97.34 627 96.68 627 96 627 C96 644.82 96 662.64 96 681 C79.64451886 681.04010881 79.64451886 681.04010881 72.421875 681.04882812 C67.5810429 681.05470076 62.74023047 681.06147229 57.89941406 681.07543945 C35.5796187 681.13814727 13.3059618 680.80248817 -9 680 C-9.3026409 625.1790125 -8.52038433 570.37151364 -7.7804445 515.55665487 C-7.60491132 502.54368558 -7.4340557 489.53065591 -7.26323819 476.51762402 C-6.89443238 448.43939004 -6.51788847 420.36126289 -6.13871133 392.2831673 C-5.9969314 381.78143441 -5.85618738 371.27968777 -5.71558356 360.77793908 C-5.4584915 341.58033059 -5.19855716 322.3827624 -4.93498993 303.1852417 C-4.8953741 300.29937895 -4.85586925 297.41351471 -4.81647491 294.52764893 C-4.45536691 268.07984364 -4.07992771 241.63295836 -3.57104874 215.18753242 C-3.10853885 191.10251891 -2.78257333 167.01735654 -2.5 142.9296875 C-2.47918494 141.16354298 -2.45836305 139.39739855 -2.43753433 137.6312542 C-2.24577075 121.34650322 -2.05816348 105.0617054 -1.875 88.77685547 C-1.78328653 80.62531272 -1.68881908 72.47380629 -1.59148407 64.32232869 C-1.54074159 60.06189996 -1.49135866 55.80146622 -1.44555664 51.54098129 C-1.26012628 34.34302824 -1.03318536 17.17310176 0 0 Z"
                                fill="#20b2aa"
                                transform="translate(490,92)"
                            />
                        </svg>
                        <span style={{ fontSize: 'clamp(1rem, 4vw, 1.5rem)', fontWeight: 700, color: '#ffffff', letterSpacing: '-0.01em' }}>
                            BitsBound
                        </span>
                    </div>
                    {/* Navigation Links */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 'clamp(8px, 3vw, 24px)' }}>
                        {[
                            { label: 'Pricing', href: '/pricing' },
                            { label: 'Docs', href: '/documentation' },
                            { label: 'About', href: '/about' },
                        ].map((navLink) => (
                            <a
                                key={navLink.href}
                                href={navLink.href}
                                className={styles.aboutLink}
                                style={{
                                    color: '#9ca3af',
                                    textDecoration: 'none',
                                    fontSize: 'clamp(12px, 3vw, 15px)',
                                    fontWeight: 500,
                                    transition: 'color 0.2s ease',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.color = '#20b2aa';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.color = '#9ca3af';
                                }}
                            >
                                {navLink.label}
                            </a>
                        ))}
                        {/* Sign In / Register Button - Navigate to Auth */}
                        <button
                            onClick={() => window.location.href = `${AUTH_BASE_URL}/auth/sign-in`}
                            className={styles.signInButton}
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 'clamp(4px, 1vw, 8px)',
                                padding: 'clamp(6px, 2vw, 10px) clamp(10px, 3vw, 20px)',
                                background: 'linear-gradient(135deg, #20b2aa 0%, #1a9a92 100%)',
                                color: '#ffffff',
                                border: 'none',
                                borderRadius: 'clamp(6px, 1.5vw, 8px)',
                                fontSize: 'clamp(11px, 2.5vw, 14px)',
                                fontWeight: 600,
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 4px 12px rgba(32, 178, 170, 0.3)',
                                whiteSpace: 'nowrap',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 6px 20px rgba(32, 178, 170, 0.5)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(32, 178, 170, 0.3)';
                            }}
                        >
                            Sign In
                        </button>
                    </div>
                </div>
                </div>
            </header>

            {/* Vertical Navigation */}
            <nav
                className={`${styles.verticalNav} ${isNavScrolled ? styles.verticalNavVisible : ""}`}
                aria-label="Page sections"
            >
                <ul className={styles.navItems}>
                    <li
                        className={`${styles.navItem} ${visibleSections.has("hero") ? styles.navActive : ""}`}
                    >
                        <a
                            href="#hero"
                            className={styles.navLink}
                            aria-label="Navigate to Hero section"
                            onClick={(e) => {
                                // Execute ExpressionStatement operation
                                e.preventDefault();
                                // Execute ExpressionStatement operation
                                document
                                    .getElementById("hero")
                                    ?.scrollIntoView({ behavior: "smooth" });
                            }}
                        >
                            <span className={styles.navDot} />
                        </a>
                    </li>
                    {/* Navigation dot for challenge section */}
                    <li
                        className={`${styles.navItem} ${visibleSections.has(SECTION_IDS.MARKET) ? styles.navActive : ""}`}
                    >
                        <a
                            href={`#${SECTION_IDS.MARKET}`}
                            className={styles.navLink}
                            aria-label="Navigate to Challenge section"
                            onClick={(e) => {
                                // Execute ExpressionStatement operation
                                e.preventDefault();
                                // Execute ExpressionStatement operation
                                document
                                    .getElementById(SECTION_IDS.MARKET)
                                    ?.scrollIntoView({ behavior: "smooth" });
                            }}
                        >
                            <span className={styles.navDot} />
                        </a>
                    </li>
                    {/* Navigation dot for solution section */}
                    <li
                        className={`${styles.navItem} ${visibleSections.has(SECTION_IDS.ADVANTAGE) ? styles.navActive : ""}`}
                    >
                        <a
                            href={`#${SECTION_IDS.ADVANTAGE}`}
                            className={styles.navLink}
                            aria-label="Navigate to Solution section"
                            onClick={(e) => {
                                // Execute ExpressionStatement operation
                                e.preventDefault();
                                // Execute ExpressionStatement operation
                                document
                                    .getElementById(SECTION_IDS.ADVANTAGE)
                                    ?.scrollIntoView({ behavior: "smooth" });
                            }}
                        >
                            <span className={styles.navDot} />
                        </a>
                    </li>
                </ul>
            </nav>
            <div
                className={`${styles.homepage} ${styles.parallax} ${className || ""}`}
            >
                {/* Skip to content link for accessibility */}
                <a href="#main-content" className={styles.srOnly}>
                    Skip to main content
                </a>
                {/* Hero Section */}
                <header className={styles.heroSection} id="hero" style={{ paddingTop: 'clamp(140px, 22vw, 180px)' }}>
                    {/* Ambient backdrop: pure CSS, replaces the four retired canvas animation systems */}
                    <div className={styles.heroAmbient} aria-hidden="true" />

                    <div className={`${styles.heroContent} ${styles.fadeInUp}`}>
                        {/* Enhanced hero title - BitsBound Platform */}
                        <h1 className={styles.heroTitle}>
                            <span className={styles.heroTitleMain}>BITSBOUND</span>
                            <span className={styles.heroTitleTagline} aria-label="Premium Single-Contract AI Automation">
                                Premium Single-Contract AI <span className={styles.highlightTeal}>Automation</span>
                            </span>
                        </h1>
                        {/* Sub-tagline */}
                        <p className={styles.heroOneLiner} style={{
                            fontSize: 'clamp(1.1rem, 2.2vw, 1.4rem)',
                            color: 'rgba(255, 255, 255, 0.85)',
                            maxWidth: '800px',
                            margin: '0 auto 1.5rem',
                            lineHeight: '1.6',
                            fontWeight: 500
                        }}>
                            Draft, Analyze, Redline, Simulate. <strong style={{ color: '#20b2aa' }}>Agentically.</strong>
                        </p>
                        {/* Founder Credibility Badge */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '0.5rem',
                            marginBottom: '1.5rem',
                            padding: '0.5rem 1rem',
                            background: 'linear-gradient(135deg, rgba(32, 178, 170, 0.15) 0%, rgba(32, 178, 170, 0.05) 100%)',
                            border: '1px solid rgba(32, 178, 170, 0.3)',
                            borderRadius: '50px',
                            width: 'fit-content',
                            margin: '0 auto 1.5rem',
                        }}>
                            <Scale size={16} color="#2dd4bf" strokeWidth={2} aria-hidden="true" />
                            <span style={{
                                color: 'rgba(255, 255, 255, 0.9)',
                                fontSize: 'clamp(0.8rem, 1.8vw, 0.95rem)',
                                fontWeight: 500,
                                letterSpacing: '0.02em'
                            }}>
                                Built by an <strong style={{ color: '#2dd4bf' }}>Attorney + Full-Stack AI Engineer</strong>
                            </span>
                        </div>
                        {/* Typewriter effect dynamically displays rotating value propositions */}
                        <p className={`${styles.heroTagline} ${styles.typewriterEffect}`} role="status" aria-live="polite" aria-atomic="true">
                            <span ref={typewriterRef} className={styles.animatedText}></span>
                            <span className={`${styles.cursor} ${styles.typewriterCursor}`} aria-hidden="true">
|
    </span>
                        </p>
                        {/* Enhanced CTA section - Get Started + Demo */}
                        <div className={`${styles.heroCta} ${styles.fadeInUp}`} role="group" aria-label="Homepage call-to-action buttons">
                            {/* Primary CTA: Get Started - Navigate to Register */}
                            <button
                                className={`${styles.ctaButton} ${styles.ctaTeal} ${styles.hoverEffect} ${styles.clickEffect}`}
                                onClick={() => window.location.href = '/auth/register'}
                                aria-label="Get started with BitsBound"
                            >
                                <span>Get Started Free</span>
                                <ArrowRight size={18} strokeWidth={2.5} aria-hidden="true" />
                            </button>
                            {/* Pricing CTA: View Pricing - Navigate to /pricing */}
                            <button
                                className={`${styles.ctaButton} ${styles.ctaSecondary} ${styles.hoverEffect} ${styles.clickEffect}`}
                                onClick={() => window.location.href = '/pricing'}
                                aria-label="View pricing plans"
                            >
                                <span>View Pricing</span>
                            </button>
                            {/* Secondary CTA: Watch the demos */}
                            <button
                                className={`${styles.ctaButton} ${styles.ctaSecondary} ${styles.hoverEffect} ${styles.clickEffect}`}
                                onClick={() => {
                                    demoVideoRef.current?.scrollIntoView({
                                        behavior: 'smooth',
                                        block: 'center'
                                    });
                                }}
                                aria-label="Watch the demo videos"
                            >
                                <Play size={16} strokeWidth={2.5} aria-hidden="true" />
                                <span>Watch the Demos</span>
                            </button>
                        </div>
                    </div>

                    <div className={`${styles.scrollIndicator} ${styles.float}`}>
                        <svg
                            width="30"
                            height="40"
                            viewBox="0 0 30 40"
                            aria-label="Scroll down"
                        >
                            <rect
                                x="5"
                                y="5"
                                width="20"
                                height="30"
                                rx="10"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                            />
                            <circle
                                cx="15"
                                cy="15"
                                r="3"
                                fill="currentColor"
                                className={styles.float}
                            />
                        </svg>
                    </div>
                </header>

                {/* Challenge Section - Get Back the 80% */}
                <section
                    className={`${styles.marketSection} ${activeSection === SECTION_IDS.MARKET ? styles.activeSection : ""}`}
                    id={SECTION_IDS.MARKET}
                    aria-labelledby="market-section-title"
                >
                    <div className={styles.container}>
                        <div className={styles.sectionHeader}>
                            <div className={styles.sectionLabel} aria-hidden="true">THE CHALLENGE</div>
                            <h2
                                id="market-section-title"
                                className={styles.sectionTitle}
                            >
                                Get Back the 80%
                            </h2>
                            <p className={styles.sectionDescription}>
                                Reading every clause. Flagging standard issues. Drafting boilerplate redlines. Writing the cover email.
                                <strong className={styles.emphasizedText}> This mechanical work consumes 80% of contract review, but requires 0% of your legal judgment.</strong>
                            </p>
                        </div>

                        {/* 80/20 Visual */}
                        <div style={{
                            maxWidth: '800px',
                            margin: '3rem auto 0',
                            padding: '0 1rem'
                        }}>
                            {/* Progress Bar Container */}
                            <div style={{
                                background: 'rgba(0, 0, 0, 0.4)',
                                borderRadius: '16px',
                                padding: 'clamp(1.5rem, 4vw, 2.5rem)',
                                border: '1px solid rgba(255, 255, 255, 0.1)'
                            }}>
                                {/* The 80/20 Bar */}
                                <div style={{
                                    display: 'flex',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                    height: 'clamp(60px, 10vw, 80px)',
                                    marginBottom: '1.5rem'
                                }}>
                                    {/* 80% - Mechanical */}
                                    <div style={{
                                        width: '80%',
                                        background: 'linear-gradient(135deg, #20b2aa 0%, #17a89f 100%)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        position: 'relative'
                                    }}>
                                        <span style={{
                                            fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
                                            fontWeight: 800,
                                            color: '#ffffff',
                                            textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
                                        }}>80%</span>
                                    </div>
                                    {/* 20% - Judgment */}
                                    <div style={{
                                        width: '20%',
                                        background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <span style={{
                                            fontSize: 'clamp(1rem, 2.5vw, 1.5rem)',
                                            fontWeight: 800,
                                            color: '#ffffff',
                                            textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
                                        }}>20%</span>
                                    </div>
                                </div>

                                {/* Labels */}
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    gap: '1rem'
                                }}>
                                    <div style={{ flex: '0 0 75%' }}>
                                        <div style={{
                                            color: '#20b2aa',
                                            fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                                            fontWeight: 600,
                                            marginBottom: '0.25rem'
                                        }}>
                                            Mechanical Work
                                        </div>
                                        <div style={{
                                            color: 'rgba(255, 255, 255, 0.6)',
                                            fontSize: 'clamp(0.75rem, 1.5vw, 0.9rem)'
                                        }}>
                                            Reading, flagging, drafting standard language
                                        </div>
                                    </div>
                                    <div style={{ flex: '0 0 20%', textAlign: 'right' }}>
                                        <div style={{
                                            color: '#f59e0b',
                                            fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                                            fontWeight: 600,
                                            marginBottom: '0.25rem'
                                        }}>
                                            Judgment
                                        </div>
                                        <div style={{
                                            color: 'rgba(255, 255, 255, 0.6)',
                                            fontSize: 'clamp(0.75rem, 1.5vw, 0.9rem)'
                                        }}>
                                            Strategy & risk
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Transition to Solution */}
                            <p style={{
                                textAlign: 'center',
                                marginTop: '2.5rem',
                                fontSize: 'clamp(1.1rem, 2.5vw, 1.4rem)',
                                color: 'rgba(255, 255, 255, 0.9)',
                                fontWeight: 500
                            }}>
                                <span style={{ color: '#20b2aa' }}>BitsBound handles the 80%</span>, so you can focus on the 20% that actually requires a lawyer.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Output Showcase: what partner-level output actually looks like, no signup required */}
                <section
                    className={styles.outputShowcaseSection}
                    id="output-showcase"
                    aria-labelledby="output-showcase-title"
                >
                    <div className={styles.container}>
                        <div className={styles.sectionHeader}>
                            <div className={styles.sectionLabel} aria-hidden="true">THE OUTPUT</div>
                            <h2 id="output-showcase-title" className={styles.sectionTitle}>
                                See the Work Product
                            </h2>
                            <p className={styles.sectionDescription}>
                                Not highlighted text. Not a chat transcript. Real Word Track Changes, margin comments with rationale,
                                and a negotiation email, exactly as they land in your download.
                            </p>
                        </div>

                        <div className={styles.outputShowcaseFrame}>
                            {/* Tab bar */}
                            <div className={styles.outputTabBar} role="tablist" aria-label="Deliverable previews">
                                <button
                                    type="button"
                                    role="tab"
                                    aria-selected={activeOutputTab === "redline"}
                                    className={`${styles.outputTab} ${activeOutputTab === "redline" ? styles.outputTabActive : ""}`}
                                    onClick={() => setActiveOutputTab("redline")}
                                >
                                    <FileText size={15} strokeWidth={2} aria-hidden="true" /> Track Changes
                                </button>
                                <button
                                    type="button"
                                    role="tab"
                                    aria-selected={activeOutputTab === "comment"}
                                    className={`${styles.outputTab} ${activeOutputTab === "comment" ? styles.outputTabActive : ""}`}
                                    onClick={() => setActiveOutputTab("comment")}
                                >
                                    <MessageSquare size={15} strokeWidth={2} aria-hidden="true" /> Margin Comment
                                </button>
                                <button
                                    type="button"
                                    role="tab"
                                    aria-selected={activeOutputTab === "email"}
                                    className={`${styles.outputTab} ${activeOutputTab === "email" ? styles.outputTabActive : ""}`}
                                    onClick={() => setActiveOutputTab("email")}
                                >
                                    <Mail size={15} strokeWidth={2} aria-hidden="true" /> Negotiation Email
                                </button>
                            </div>

                            {/* Document chrome */}
                            <div className={styles.outputDocChrome}>
                                <span className={styles.outputDocDot} />
                                <span className={styles.outputDocDot} />
                                <span className={styles.outputDocDot} />
                                <span className={styles.outputDocFilename}>
                                    {activeOutputTab === "email" ? "negotiation-email-draft.txt" : "MSA_Acme_Redlined.docx"}
                                </span>
                            </div>

                            {/* Panels */}
                            {activeOutputTab === "redline" && (
                                <div className={styles.outputDocBody} role="tabpanel" aria-label="Track Changes preview">
                                    <p className={styles.outputDocClauseTitle}>11.2&ensp;Limitation of Liability.</p>
                                    <p className={styles.outputDocText}>
                                        IN NO EVENT SHALL EITHER PARTY&apos;S AGGREGATE LIABILITY ARISING OUT OF OR RELATED TO THIS
                                        AGREEMENT EXCEED <del className={styles.tcDel}>THE FEES PAID BY CUSTOMER IN THE THREE (3) MONTHS</del>
                                        {" "}<ins className={styles.tcIns}>THE GREATER OF (A) TWO TIMES (2X) THE FEES PAID OR PAYABLE BY
                                        CUSTOMER IN THE TWELVE (12) MONTHS</ins> PRECEDING THE EVENT GIVING RISE TO THE
                                        CLAIM<ins className={styles.tcIns}>, OR (B) ONE MILLION DOLLARS ($1,000,000)</ins>.
                                        {" "}<ins className={styles.tcIns}>THE FOREGOING LIMITATION SHALL NOT APPLY TO PROVIDER&apos;S
                                        INDEMNIFICATION OBLIGATIONS UNDER SECTION 12, BREACH OF SECTION 9 (CONFIDENTIALITY), OR PROVIDER&apos;S
                                        BREACH OF SECTION 10 (DATA PROTECTION).</ins>
                                    </p>
                                    <div className={styles.outputDocMeta}>
                                        <span className={styles.tcAuthorChip}>BitsBound SAC</span>
                                        <span>2 insertions, 1 deletion, applied as native OOXML w:ins / w:del</span>
                                    </div>
                                </div>
                            )}

                            {activeOutputTab === "comment" && (
                                <div className={styles.outputDocBody} role="tabpanel" aria-label="Margin comment preview">
                                    <div className={styles.outputCommentCard}>
                                        <div className={styles.outputCommentHeader}>
                                            <span className={styles.tcAuthorChip}>BitsBound SAC</span>
                                            <span className={styles.outputCommentRef}>re: § 11.2 Limitation of Liability</span>
                                        </div>
                                        <p className={styles.outputCommentText}>
                                            The 3-month fee cap is far below market for enterprise SaaS (12-month caps appear in roughly
                                            80% of comparable deals). A 2x/12-month cap with a $1M floor restores balance, and carving out
                                            indemnification, confidentiality, and data-protection breaches protects you where exposure is
                                            asymmetric. Flagged HIGH risk: this clause currently shifts catastrophic-loss exposure to you.
                                        </p>
                                        <div className={styles.outputCommentRisk}>
                                            <span className={styles.riskPillHigh}>HIGH RISK</span>
                                            <span className={styles.riskPillScore}>Favorability: 18/100 → 74/100 after redline</span>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {activeOutputTab === "email" && (
                                <div className={styles.outputDocBody} role="tabpanel" aria-label="Negotiation email preview">
                                    <p className={styles.outputEmailLine}><strong>Subject:</strong> Acme MSA: our markup and three points of rationale</p>
                                    <p className={styles.outputEmailLine}>Hi Jordan,</p>
                                    <p className={styles.outputEmailLine}>
                                        Thanks for sending the draft MSA. Attached is our markup; the changes concentrate on three areas:
                                    </p>
                                    <p className={styles.outputEmailLine}>
                                        <strong>1. Liability cap (§ 11.2).</strong> The 3-month fee cap is below market for a deal of this
                                        size. We have proposed 2x trailing-12-month fees with a $1M floor, with standard carve-outs for
                                        indemnification, confidentiality, and data-protection breaches.
                                    </p>
                                    <p className={styles.outputEmailLine}>
                                        <strong>2. Service credits (§ 4.3).</strong> We added a 99.9% uptime commitment with graduated
                                        credits, consistent with your published SLA.
                                    </p>
                                    <p className={styles.outputEmailLineMuted}>
                                        ...continues with change-by-change rationale, ready for your review and personalization.
                                    </p>
                                </div>
                            )}

                            <p className={styles.outputShowcaseDisclaimer}>
                                Illustrative excerpt from a sample analysis. Every output is a draft for attorney review, not legal advice.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Section: Two Worlds - How BitsBound Works */}
                <section
                    className={`${styles.bubsaSection} ${activeSection === SECTION_IDS.BUBSA ? styles.activeSection : ""}`}
                    id={SECTION_IDS.BUBSA}
                    aria-labelledby="modes-section-title"
                >
                    <div className={styles.container}>
                        <div className={styles.sectionHeader}>
                            <div className={styles.sectionLabel} aria-hidden="true">HOW IT WORKS</div>
                            <h2
                                id="modes-section-title"
                                className={styles.sectionTitle}
                            >
                                Two Worlds. Six Modes. One Platform.
                            </h2>
                            <p className={styles.sectionDescription}>
                                Fight for YOUR position in Adversarial World, or find what works for BOTH sides in Neutral World. Choose your approach based on your relationship and goals.
                            </p>
                        </div>

                        {/* ═══════════════════════════════════════════════════════════════ */}
                        {/* ADVERSARIAL WORLD - Fight for YOUR side */}
                        {/* ═══════════════════════════════════════════════════════════════ */}
                        <div style={{ marginTop: '3rem' }}>
                            {/* World Header */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '1rem',
                                marginBottom: '1.5rem',
                                paddingBottom: '1rem',
                                borderBottom: '1px solid rgba(239, 68, 68, 0.3)'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '52px',
                                    height: '52px',
                                    borderRadius: '14px',
                                    background: 'rgba(239, 68, 68, 0.12)',
                                    border: '1px solid rgba(239, 68, 68, 0.35)'
                                }}>
                                    <Swords size={26} color="#ef4444" strokeWidth={2} aria-hidden="true" />
                                </div>
                                <div>
                                    <h3 style={{
                                        color: '#ef4444',
                                        fontSize: 'clamp(1.4rem, 2.5vw, 1.8rem)',
                                        fontWeight: '800',
                                        margin: 0,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em'
                                    }}>
                                        Adversarial World
                                    </h3>
                                    <p style={{
                                        color: 'rgba(255, 255, 255, 0.6)',
                                        fontSize: '0.95rem',
                                        margin: '0.25rem 0 0 0'
                                    }}>
                                        Attack contracts. Protect YOUR position. Win negotiations.
                                    </p>
                                </div>
                            </div>

                            {/* Adversarial Modes Grid */}
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 320px), 1fr))',
                                gap: 'clamp(1.25rem, 2.5vw, 1.75rem)'
                            }}>
                                {/* Redline Mode */}
                                <div style={{
                                    background: 'linear-gradient(135deg, rgba(20, 20, 20, 0.95) 0%, rgba(30, 30, 30, 0.95) 100%)',
                                    border: '1px solid rgba(239, 68, 68, 0.3)',
                                    borderRadius: '16px',
                                    padding: 'clamp(1.25rem, 3vw, 2rem)',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: '12px',
                                        right: '12px',
                                        background: 'linear-gradient(135deg, #ef4444, #dc2626)',
                                        color: '#ffffff',
                                        padding: '5px 12px',
                                        borderRadius: '16px',
                                        fontSize: '0.7rem',
                                        fontWeight: '700',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em'
                                    }}>
                                        Redline
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '44px', height: '44px', borderRadius: '12px', background: 'rgba(239, 68, 68, 0.12)', border: '1px solid rgba(239, 68, 68, 0.3)', marginBottom: '0.85rem' }}>
                                        <FileText size={22} color="#ef4444" strokeWidth={2} aria-hidden="true" />
                                    </div>

                                    <h4 style={{
                                        color: '#ffffff',
                                        fontSize: 'clamp(1.15rem, 2vw, 1.35rem)',
                                        fontWeight: '700',
                                        marginBottom: '0.5rem'
                                    }}>
                                        Swarm-Powered Redlines
                                    </h4>

                                    <p style={{
                                        color: 'rgba(255, 255, 255, 0.7)',
                                        fontSize: 'clamp(0.85rem, 1.3vw, 0.95rem)',
                                        lineHeight: '1.55',
                                        marginBottom: '1rem'
                                    }}>
                                        Upload counterparty's contract. 150+ parallel AI agents attack every clause and generate partner-level redlines with real Track Changes.
                                    </p>

                                    <div style={{ borderTop: '1px solid rgba(255, 255, 255, 0.1)', paddingTop: '1rem' }}>
                                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                            {['Redlined DOCX with Track Changes', 'Negotiation email draft', 'Risk dashboard'].map((item, i) => (
                                                <li key={i} style={{
                                                    color: 'rgba(255, 255, 255, 0.8)',
                                                    fontSize: '0.85rem',
                                                    padding: '0.3rem 0',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '0.4rem'
                                                }}>
                                                    <span style={{ color: '#ef4444' }}>✓</span> {item}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div style={{
                                        marginTop: '1rem',
                                        padding: '0.6rem 0.85rem',
                                        background: 'rgba(239, 68, 68, 0.1)',
                                        borderRadius: '8px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}>
                                        <span style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '0.8rem' }}>Turnaround</span>
                                        <span style={{ color: '#ef4444', fontWeight: '700', fontSize: '0.9rem' }}>~45 min</span>
                                    </div>
                                </div>

                                {/* Draft Mode */}
                                <div style={{
                                    background: 'linear-gradient(135deg, rgba(20, 20, 20, 0.95) 0%, rgba(30, 30, 30, 0.95) 100%)',
                                    border: '1px solid rgba(32, 178, 170, 0.3)',
                                    borderRadius: '16px',
                                    padding: 'clamp(1.25rem, 3vw, 2rem)',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: '12px',
                                        right: '12px',
                                        background: 'linear-gradient(135deg, #20b2aa, #14b8a6)',
                                        color: '#0a0a0a',
                                        padding: '5px 12px',
                                        borderRadius: '16px',
                                        fontSize: '0.7rem',
                                        fontWeight: '700',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em'
                                    }}>
                                        Draft
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '44px', height: '44px', borderRadius: '12px', background: 'rgba(32, 178, 170, 0.12)', border: '1px solid rgba(32, 178, 170, 0.3)', marginBottom: '0.85rem' }}>
                                        <PenLine size={22} color="#20b2aa" strokeWidth={2} aria-hidden="true" />
                                    </div>

                                    <h4 style={{
                                        color: '#ffffff',
                                        fontSize: 'clamp(1.15rem, 2vw, 1.35rem)',
                                        fontWeight: '700',
                                        marginBottom: '0.5rem'
                                    }}>
                                        Multi-Pass Drafting
                                    </h4>

                                    <p style={{
                                        color: 'rgba(255, 255, 255, 0.7)',
                                        fontSize: 'clamp(0.85rem, 1.3vw, 0.95rem)',
                                        lineHeight: '1.55',
                                        marginBottom: '1rem'
                                    }}>
                                        Describe your deal. Three Opus passes + 16 parallel analyzers generate a complete contract optimized for YOUR position. Control the paper.
                                    </p>

                                    <div style={{ borderTop: '1px solid rgba(255, 255, 255, 0.1)', paddingTop: '1rem' }}>
                                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                            {['Complete contract DOCX', 'Position-optimized clauses', 'Partner-level quality'].map((item, i) => (
                                                <li key={i} style={{
                                                    color: 'rgba(255, 255, 255, 0.8)',
                                                    fontSize: '0.85rem',
                                                    padding: '0.3rem 0',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '0.4rem'
                                                }}>
                                                    <span style={{ color: '#20b2aa' }}>✓</span> {item}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div style={{
                                        marginTop: '1rem',
                                        padding: '0.6rem 0.85rem',
                                        background: 'rgba(32, 178, 170, 0.1)',
                                        borderRadius: '8px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}>
                                        <span style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '0.8rem' }}>Turnaround</span>
                                        <span style={{ color: '#20b2aa', fontWeight: '700', fontSize: '0.9rem' }}>~60 min</span>
                                    </div>
                                </div>

                                {/* Collaborate Mode */}
                                <div style={{
                                    background: 'linear-gradient(135deg, rgba(20, 20, 20, 0.95) 0%, rgba(30, 30, 30, 0.95) 100%)',
                                    border: '1px solid rgba(168, 85, 247, 0.3)',
                                    borderRadius: '16px',
                                    padding: 'clamp(1.25rem, 3vw, 2rem)',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: '12px',
                                        right: '12px',
                                        background: 'linear-gradient(135deg, #a855f7, #9333ea)',
                                        color: '#ffffff',
                                        padding: '5px 12px',
                                        borderRadius: '16px',
                                        fontSize: '0.7rem',
                                        fontWeight: '700',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em'
                                    }}>
                                        Collaborate
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '44px', height: '44px', borderRadius: '12px', background: 'rgba(168, 85, 247, 0.12)', border: '1px solid rgba(168, 85, 247, 0.3)', marginBottom: '0.85rem' }}>
                                        <MessageSquare size={22} color="#a855f7" strokeWidth={2} aria-hidden="true" />
                                    </div>

                                    <h4 style={{
                                        color: '#ffffff',
                                        fontSize: 'clamp(1.15rem, 2vw, 1.35rem)',
                                        fontWeight: '700',
                                        marginBottom: '0.5rem'
                                    }}>
                                        Chat With SAC
                                    </h4>

                                    <p style={{
                                        color: 'rgba(255, 255, 255, 0.7)',
                                        fontSize: 'clamp(0.85rem, 1.3vw, 0.95rem)',
                                        lineHeight: '1.55',
                                        marginBottom: '1rem'
                                    }}>
                                        Skip the pipeline: chat with Supreme AI Co-Counsel instantly. Partner-level Track Changes and drafts in real time. No wait.
                                    </p>

                                    <div style={{ borderTop: '1px solid rgba(255, 255, 255, 0.1)', paddingTop: '1rem' }}>
                                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                            {['Instant redlines & drafts', 'Real OOXML Track Changes', 'Download DOCX anytime'].map((item, i) => (
                                                <li key={i} style={{
                                                    color: 'rgba(255, 255, 255, 0.8)',
                                                    fontSize: '0.85rem',
                                                    padding: '0.3rem 0',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '0.4rem'
                                                }}>
                                                    <span style={{ color: '#a855f7' }}>✓</span> {item}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div style={{
                                        marginTop: '1rem',
                                        padding: '0.6rem 0.85rem',
                                        background: 'rgba(168, 85, 247, 0.1)',
                                        borderRadius: '8px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}>
                                        <span style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '0.8rem' }}>Turnaround</span>
                                        <span style={{ color: '#a855f7', fontWeight: '700', fontSize: '0.9rem' }}>Instant</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ═══════════════════════════════════════════════════════════════ */}
                        {/* NEUTRAL WORLD - Find what works for BOTH sides */}
                        {/* ═══════════════════════════════════════════════════════════════ */}
                        <div style={{ marginTop: '3.5rem' }}>
                            {/* World Header */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '1rem',
                                marginBottom: '1.5rem',
                                paddingBottom: '1rem',
                                borderBottom: '1px solid rgba(245, 158, 11, 0.3)'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '52px',
                                    height: '52px',
                                    borderRadius: '14px',
                                    background: 'rgba(245, 158, 11, 0.12)',
                                    border: '1px solid rgba(245, 158, 11, 0.35)'
                                }}>
                                    <Scale size={26} color="#f59e0b" strokeWidth={2} aria-hidden="true" />
                                </div>
                                <div>
                                    <h3 style={{
                                        color: '#f59e0b',
                                        fontSize: 'clamp(1.4rem, 2.5vw, 1.8rem)',
                                        fontWeight: '800',
                                        margin: 0,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em'
                                    }}>
                                        Neutral World
                                    </h3>
                                    <p style={{
                                        color: 'rgba(255, 255, 255, 0.6)',
                                        fontSize: '0.95rem',
                                        margin: '0.25rem 0 0 0'
                                    }}>
                                        Simulate negotiation. Find the optimal deal for BOTH sides. Skip negotiation, or use it as leverage.
                                    </p>
                                </div>
                            </div>

                            {/* Neutral Modes Grid */}
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 320px), 1fr))',
                                gap: 'clamp(1.25rem, 2.5vw, 1.75rem)'
                            }}>
                                {/* Mode 0: Preference-Only */}
                                <div style={{
                                    background: 'linear-gradient(135deg, rgba(20, 20, 20, 0.95) 0%, rgba(30, 30, 30, 0.95) 100%)',
                                    border: '1px solid rgba(245, 158, 11, 0.3)',
                                    borderRadius: '16px',
                                    padding: 'clamp(1.25rem, 3vw, 2rem)',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: '12px',
                                        right: '12px',
                                        background: 'linear-gradient(135deg, #f59e0b, #d97706)',
                                        color: '#0a0a0a',
                                        padding: '5px 12px',
                                        borderRadius: '16px',
                                        fontSize: '0.7rem',
                                        fontWeight: '700',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em'
                                    }}>
                                        Mode 0
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '44px', height: '44px', borderRadius: '12px', background: 'rgba(245, 158, 11, 0.12)', border: '1px solid rgba(245, 158, 11, 0.3)', marginBottom: '0.85rem' }}>
                                        <Sprout size={22} color="#f59e0b" strokeWidth={2} aria-hidden="true" />
                                    </div>

                                    <h4 style={{
                                        color: '#ffffff',
                                        fontSize: 'clamp(1.15rem, 2vw, 1.35rem)',
                                        fontWeight: '700',
                                        marginBottom: '0.5rem'
                                    }}>
                                        Preference-Only
                                    </h4>

                                    <p style={{
                                        color: 'rgba(255, 255, 255, 0.7)',
                                        fontSize: 'clamp(0.85rem, 1.3vw, 0.95rem)',
                                        lineHeight: '1.55',
                                        marginBottom: '1rem'
                                    }}>
                                        No contracts yet? Enter both parties' priorities and constraints. AI generates a balanced agreement from scratch.
                                    </p>

                                    <div style={{ borderTop: '1px solid rgba(255, 255, 255, 0.1)', paddingTop: '1rem' }}>
                                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                            {['Balanced contract from scratch', 'Decision report with tradeoffs', 'Market benchmark analysis'].map((item, i) => (
                                                <li key={i} style={{
                                                    color: 'rgba(255, 255, 255, 0.8)',
                                                    fontSize: '0.85rem',
                                                    padding: '0.3rem 0',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '0.4rem'
                                                }}>
                                                    <span style={{ color: '#f59e0b' }}>✓</span> {item}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div style={{
                                        marginTop: '1rem',
                                        padding: '0.6rem 0.85rem',
                                        background: 'rgba(245, 158, 11, 0.1)',
                                        borderRadius: '8px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}>
                                        <span style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '0.8rem' }}>Best for</span>
                                        <span style={{ color: '#f59e0b', fontWeight: '600', fontSize: '0.85rem' }}>Early-stage deals</span>
                                    </div>
                                </div>

                                {/* Mode 1: Single-Anchor */}
                                <div style={{
                                    background: 'linear-gradient(135deg, rgba(20, 20, 20, 0.95) 0%, rgba(30, 30, 30, 0.95) 100%)',
                                    border: '1px solid rgba(251, 191, 36, 0.3)',
                                    borderRadius: '16px',
                                    padding: 'clamp(1.25rem, 3vw, 2rem)',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: '12px',
                                        right: '12px',
                                        background: 'linear-gradient(135deg, #fbbf24, #f59e0b)',
                                        color: '#0a0a0a',
                                        padding: '5px 12px',
                                        borderRadius: '16px',
                                        fontSize: '0.7rem',
                                        fontWeight: '700',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em'
                                    }}>
                                        Mode 1
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '44px', height: '44px', borderRadius: '12px', background: 'rgba(251, 191, 36, 0.12)', border: '1px solid rgba(251, 191, 36, 0.3)', marginBottom: '0.85rem' }}>
                                        <File size={22} color="#fbbf24" strokeWidth={2} aria-hidden="true" />
                                    </div>

                                    <h4 style={{
                                        color: '#ffffff',
                                        fontSize: 'clamp(1.15rem, 2vw, 1.35rem)',
                                        fontWeight: '700',
                                        marginBottom: '0.5rem'
                                    }}>
                                        Single-Anchor
                                    </h4>

                                    <p style={{
                                        color: 'rgba(255, 255, 255, 0.7)',
                                        fontSize: 'clamp(0.85rem, 1.3vw, 0.95rem)',
                                        lineHeight: '1.55',
                                        marginBottom: '1rem'
                                    }}>
                                        Have one draft? Upload it with counterparty preferences. AI balances the existing contract against the other side's priorities.
                                    </p>

                                    <div style={{ borderTop: '1px solid rgba(255, 255, 255, 0.1)', paddingTop: '1rem' }}>
                                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                            {['Rebalanced contract', 'Gap analysis report', 'Fairness scoring'].map((item, i) => (
                                                <li key={i} style={{
                                                    color: 'rgba(255, 255, 255, 0.8)',
                                                    fontSize: '0.85rem',
                                                    padding: '0.3rem 0',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '0.4rem'
                                                }}>
                                                    <span style={{ color: '#fbbf24' }}>✓</span> {item}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div style={{
                                        marginTop: '1rem',
                                        padding: '0.6rem 0.85rem',
                                        background: 'rgba(251, 191, 36, 0.1)',
                                        borderRadius: '8px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}>
                                        <span style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '0.8rem' }}>Best for</span>
                                        <span style={{ color: '#fbbf24', fontWeight: '600', fontSize: '0.85rem' }}>Vendor templates</span>
                                    </div>
                                </div>

                                {/* Mode 2: Dual-Draft */}
                                <div style={{
                                    background: 'linear-gradient(135deg, rgba(20, 20, 20, 0.95) 0%, rgba(30, 30, 30, 0.95) 100%)',
                                    border: '1px solid rgba(234, 179, 8, 0.3)',
                                    borderRadius: '16px',
                                    padding: 'clamp(1.25rem, 3vw, 2rem)',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: '12px',
                                        right: '12px',
                                        background: 'linear-gradient(135deg, #eab308, #ca8a04)',
                                        color: '#0a0a0a',
                                        padding: '5px 12px',
                                        borderRadius: '16px',
                                        fontSize: '0.7rem',
                                        fontWeight: '700',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em'
                                    }}>
                                        Mode 2
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '44px', height: '44px', borderRadius: '12px', background: 'rgba(234, 179, 8, 0.12)', border: '1px solid rgba(234, 179, 8, 0.3)', marginBottom: '0.85rem' }}>
                                        <Files size={22} color="#eab308" strokeWidth={2} aria-hidden="true" />
                                    </div>

                                    <h4 style={{
                                        color: '#ffffff',
                                        fontSize: 'clamp(1.15rem, 2vw, 1.35rem)',
                                        fontWeight: '700',
                                        marginBottom: '0.5rem'
                                    }}>
                                        Dual-Draft
                                    </h4>

                                    <p style={{
                                        color: 'rgba(255, 255, 255, 0.7)',
                                        fontSize: 'clamp(0.85rem, 1.3vw, 0.95rem)',
                                        lineHeight: '1.55',
                                        marginBottom: '1rem'
                                    }}>
                                        Both sides have drafts? Upload both. AI finds where you actually agree, eliminates phantom disagreements, and synthesizes a third document.
                                    </p>

                                    <div style={{ borderTop: '1px solid rgba(255, 255, 255, 0.1)', paddingTop: '1rem' }}>
                                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                            {['Synthesized third document', 'Overlap & conflict analysis', 'Removes ego attachment'].map((item, i) => (
                                                <li key={i} style={{
                                                    color: 'rgba(255, 255, 255, 0.8)',
                                                    fontSize: '0.85rem',
                                                    padding: '0.3rem 0',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '0.4rem'
                                                }}>
                                                    <span style={{ color: '#eab308' }}>✓</span> {item}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div style={{
                                        marginTop: '1rem',
                                        padding: '0.6rem 0.85rem',
                                        background: 'rgba(234, 179, 8, 0.1)',
                                        borderRadius: '8px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}>
                                        <span style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '0.8rem' }}>Best for</span>
                                        <span style={{ color: '#eab308', fontWeight: '600', fontSize: '0.85rem' }}>M&A / high-stakes</span>
                                    </div>
                                </div>
                            </div>

                            {/* Neutral World Value Prop */}
                            <div style={{
                                marginTop: '2rem',
                                padding: '1.25rem 1.5rem',
                                background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.08) 0%, rgba(234, 179, 8, 0.05) 100%)',
                                border: '1px solid rgba(245, 158, 11, 0.2)',
                                borderRadius: '12px',
                                textAlign: 'center'
                            }}>
                                <p style={{
                                    color: 'rgba(255, 255, 255, 0.85)',
                                    fontSize: '1rem',
                                    margin: 0,
                                    lineHeight: '1.6'
                                }}>
                                    <strong style={{ color: '#f59e0b' }}>The Core Insight:</strong> Neutral World doesn&apos;t compromise; it reveals the agreement that <em>already exists</em> given both parties&apos; real constraints. Use it as the final deal, or as a fairness reference in your negotiation.
                                </p>
                            </div>
                        </div>

                        {/* Pipeline Stats */}
                        <div className={styles.bubsaStatsGrid} style={{ marginTop: '3rem' }}>
                            <div className={styles.bubsaStat}>
                                <div className={`${styles.bubsaStatNumber} ${styles.shimmer}`}>150+</div>
                                <div className={styles.bubsaStatLabel}>Parallel Analyzers</div>
                            </div>
                            <div className={styles.bubsaStat}>
                                <div className={`${styles.bubsaStatNumber} ${styles.shimmer}`}>9</div>
                                <div className={styles.bubsaStatLabel}>Contract Verticals</div>
                            </div>
                            <div className={styles.bubsaStat}>
                                <div className={`${styles.bubsaStatNumber} ${styles.shimmer}`}>3</div>
                                <div className={styles.bubsaStatLabel}>Opus Passes</div>
                            </div>
                            <div className={styles.bubsaStat}>
                                <div className={`${styles.bubsaStatNumber} ${styles.shimmer}`}>~$30</div>
                                <div className={styles.bubsaStatLabel}>Typical Contract</div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* AI Judges' Verdict - Three Independent AI Models Validate BitsBound (data-driven render) */}
                <section
                    id="ai-judges-verdict"
                    aria-labelledby="ai-judges-title"
                    className={styles.judgesSection}
                >
                    <div className={styles.judgesGlow} aria-hidden="true" />
                    <div className={styles.container}>
                        <div className={styles.sectionHeader}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '8px' }}>
                                <div className={styles.sectionLabel} aria-hidden="true">VALIDATED BY AI</div>
                                <div className={`${styles.judgeModeBadge} ${styles.judgeModeBadgeDraft}`}>Draft Mode Results</div>
                            </div>
                            <h2 id="ai-judges-title" className={styles.sectionTitle} style={{ marginBottom: '1rem' }}>
                                3 Independent AI Judges. 1 Clear Winner.
                            </h2>
                            <p className={styles.sectionDescription} style={{ maxWidth: '800px', margin: '0 auto' }}>
                                In blind evaluations, three leading AI models compared two contract outputs: one from the leading single-shot LLM (Claude Opus 4.5 via claude.ai), one from BitsBound&apos;s multi-pass pipeline.
                                <strong style={{ color: '#20b2aa' }}> All three judges chose BitsBound in both Draft Mode and Redline Mode.</strong>
                            </p>
                        </div>

                        <div className={styles.judgeGrid} style={{ marginTop: '3rem' }}>
                            {JUDGE_RESULTS.draft.map((result) => (
                                <div key={`draft-${result.judge}`} className={`${styles.judgeCard} ${styles.judgeCardDraft}`}>
                                    <div className={`${styles.judgeWinnerBadge} ${styles.judgeWinnerBadgeDraft}`}>Winner: BitsBound</div>
                                    <div style={{ marginBottom: '1.5rem' }}>
                                        <h3 className={styles.judgeName}>{result.judge}</h3>
                                        <p className={styles.judgeOrg}>{result.org}</p>
                                    </div>
                                    <div className={styles.judgeScoreRow}>
                                        <div style={{ textAlign: 'center' }}>
                                            <div className={`${styles.judgeScore} ${styles.judgeScoreTeal}`}>{result.bitsbound}</div>
                                            <div className={styles.judgeScoreLabel}>BitsBound</div>
                                        </div>
                                        <div className={styles.judgeVs}>vs</div>
                                        <div style={{ textAlign: 'center' }}>
                                            <div className={styles.judgeScoreMuted}>{result.claudeAi}</div>
                                            <div className={styles.judgeScoreLabelMuted}>Claude.ai</div>
                                        </div>
                                    </div>
                                    <div className={`${styles.judgeDeltaRow} ${styles.judgeDeltaRowDraft}`}>
                                        <span aria-hidden="true">↑</span>
                                        <span style={{ fontWeight: 600 }}>{result.delta}</span>
                                        <span className={styles.judgeMargin}>({result.margin})</span>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className={`${styles.judgeInsight} ${styles.judgeInsightDraft}`}>
                            <p style={{ margin: 0 }}>
                                <strong style={{ color: '#20b2aa' }}>The insight:</strong> Multi-pass architecture catches issues that single-pass models miss.
                            </p>
                        </div>

                        {/* Redline Mode Results */}
                        <div style={{ marginTop: 'clamp(4rem, 8vw, 6rem)' }}>
                            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                                <div className={`${styles.judgeModeBadge} ${styles.judgeModeBadgeRedline}`} style={{ marginBottom: '16px', display: 'inline-flex' }}>
                                    Redline Mode Results
                                </div>
                                <p className={styles.judgeRedlineSub}>
                                    Same three AI judges evaluated MSA redlines. BitsBound swept again.
                                </p>
                            </div>

                            <div className={styles.judgeGrid}>
                                {JUDGE_RESULTS.redline.map((result) => (
                                    <div key={`redline-${result.judge}`} className={`${styles.judgeCard} ${styles.judgeCardRedline}`}>
                                        <div className={`${styles.judgeWinnerBadge} ${styles.judgeWinnerBadgeRedline}`}>Winner: BitsBound</div>
                                        <div style={{ marginBottom: '1.5rem' }}>
                                            <h3 className={styles.judgeName}>{result.judge}</h3>
                                            <p className={styles.judgeOrg}>{result.org}</p>
                                        </div>
                                        <div className={styles.judgeScoreRow}>
                                            <div style={{ textAlign: 'center' }}>
                                                <div className={`${styles.judgeScore} ${styles.judgeScoreRed}`}>{result.bitsbound}</div>
                                                <div className={styles.judgeScoreLabel}>BitsBound</div>
                                            </div>
                                            <div className={styles.judgeVs}>vs</div>
                                            <div style={{ textAlign: 'center' }}>
                                                <div className={styles.judgeScoreMuted}>{result.claudeAi}</div>
                                                <div className={styles.judgeScoreLabelMuted}>Claude.ai</div>
                                            </div>
                                        </div>
                                        <div className={`${styles.judgeDeltaRow} ${styles.judgeDeltaRowRedline}`}>
                                            <span aria-hidden="true">↑</span>
                                            <span style={{ fontWeight: 600 }}>{result.delta}</span>
                                            <span className={styles.judgeMargin}>({result.margin})</span>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className={`${styles.judgeInsight} ${styles.judgeInsightRedline}`}>
                                <p style={{ margin: 0 }}>
                                    <strong style={{ color: '#ff6b6b' }}>The insight:</strong> Adversarial ping-pong refinement produces more defensible redlines.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* T_LEGAL_AI_STACK_2026_01_08: Complete Your Legal AI Stack Section */}
                <section
                    className={`${styles.bubsaSection} ${activeSection === SECTION_IDS.VS_HARVEY ? styles.activeSection : ""}`}
                    id={SECTION_IDS.VS_HARVEY}
                    aria-labelledby="vs-harvey-section-title"
                    style={{
                        background: 'linear-gradient(180deg, rgba(10, 10, 10, 0.95) 0%, rgba(20, 20, 25, 0.98) 100%)',
                        borderTop: '1px solid rgba(32, 178, 170, 0.15)',
                        borderBottom: '1px solid rgba(32, 178, 170, 0.15)'
                    }}
                >
                    <div className={styles.container}>
                        <div className={styles.sectionHeader}>
                            <div className={styles.sectionLabel} aria-hidden="true">WHERE WE FIT</div>
                            <h2
                                id="vs-harvey-section-title"
                                className={styles.sectionTitle}
                            >
                                Complete Your Legal AI Stack
                            </h2>
                            <p className={styles.sectionDescription}>
                                The single-contract execution layer.
                            </p>
                        </div>

                        {/* Stack Diagram */}
                        <div style={{
                            maxWidth: '900px',
                            margin: '0 auto',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '1rem'
                        }}>
                            {/* Research Layer */}
                            <div style={{
                                background: 'linear-gradient(135deg, rgba(100, 100, 120, 0.15) 0%, rgba(100, 100, 120, 0.05) 100%)',
                                border: '1px solid rgba(150, 150, 170, 0.3)',
                                borderRadius: '16px',
                                padding: 'clamp(1.25rem, 3vw, 1.75rem)',
                                display: 'grid',
                                gridTemplateColumns: '1fr 2fr 2fr',
                                alignItems: 'center',
                                gap: '1rem'
                            }}>
                                <div style={{
                                    fontSize: 'clamp(0.75rem, 1.5vw, 0.9rem)',
                                    fontWeight: 700,
                                    color: 'rgba(150, 150, 170, 0.9)',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.05em'
                                }}>
                                    Research
                                </div>
                                <div style={{
                                    fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                                    fontWeight: 600,
                                    color: 'rgba(255, 255, 255, 0.7)'
                                }}>
                                    Harvey, Copilot
                                </div>
                                <div style={{
                                    fontSize: 'clamp(0.85rem, 1.8vw, 1rem)',
                                    color: 'rgba(255, 255, 255, 0.5)',
                                    fontStyle: 'italic'
                                }}>
                                    &quot;What does the law say about X?&quot;
                                </div>
                            </div>

                            {/* Repository Layer */}
                            <div style={{
                                background: 'linear-gradient(135deg, rgba(100, 100, 120, 0.15) 0%, rgba(100, 100, 120, 0.05) 100%)',
                                border: '1px solid rgba(150, 150, 170, 0.3)',
                                borderRadius: '16px',
                                padding: 'clamp(1.25rem, 3vw, 1.75rem)',
                                display: 'grid',
                                gridTemplateColumns: '1fr 2fr 2fr',
                                alignItems: 'center',
                                gap: '1rem'
                            }}>
                                <div style={{
                                    fontSize: 'clamp(0.75rem, 1.5vw, 0.9rem)',
                                    fontWeight: 700,
                                    color: 'rgba(150, 150, 170, 0.9)',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.05em'
                                }}>
                                    Repository
                                </div>
                                <div style={{
                                    fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                                    fontWeight: 600,
                                    color: 'rgba(255, 255, 255, 0.7)'
                                }}>
                                    CLMs (Ironclad, Icertis)
                                </div>
                                <div style={{
                                    fontSize: 'clamp(0.85rem, 1.8vw, 1rem)',
                                    color: 'rgba(255, 255, 255, 0.5)',
                                    fontStyle: 'italic'
                                }}>
                                    &quot;Where are our contracts?&quot;
                                </div>
                            </div>

                            {/* Execution Layer - BitsBound (highlighted) */}
                            <div style={{
                                background: 'linear-gradient(135deg, rgba(32, 178, 170, 0.2) 0%, rgba(32, 178, 170, 0.08) 100%)',
                                border: '2px solid rgba(32, 178, 170, 0.5)',
                                borderRadius: '16px',
                                padding: 'clamp(1.5rem, 3vw, 2rem)',
                                display: 'grid',
                                gridTemplateColumns: '1fr 2fr 2fr',
                                alignItems: 'center',
                                gap: '1rem',
                                boxShadow: '0 0 30px rgba(32, 178, 170, 0.15)'
                            }}>
                                <div style={{
                                    fontSize: 'clamp(0.75rem, 1.5vw, 0.9rem)',
                                    fontWeight: 700,
                                    color: '#20b2aa',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.05em'
                                }}>
                                    Execution
                                </div>
                                <div style={{
                                    fontSize: 'clamp(1.1rem, 2.2vw, 1.4rem)',
                                    fontWeight: 700,
                                    color: '#20b2aa'
                                }}>
                                    BitsBound
                                </div>
                                <div style={{
                                    fontSize: 'clamp(0.9rem, 1.8vw, 1.05rem)',
                                    color: 'rgba(255, 255, 255, 0.9)',
                                    fontStyle: 'italic',
                                    fontWeight: 500
                                }}>
                                    &quot;THIS contract. Partner-grade. Now.&quot;
                                </div>
                            </div>
                        </div>

                        {/* Works With Your Stack */}
                        <div style={{
                            marginTop: 'clamp(2rem, 4vw, 3rem)',
                            textAlign: 'center',
                            padding: '1.5rem 2rem',
                            background: 'linear-gradient(135deg, rgba(32, 178, 170, 0.12) 0%, rgba(32, 178, 170, 0.04) 100%)',
                            border: '1px solid rgba(32, 178, 170, 0.25)',
                            borderRadius: '16px',
                            maxWidth: '800px',
                            margin: 'clamp(2rem, 4vw, 3rem) auto 0'
                        }}>
                            <p style={{
                                color: 'rgba(255, 255, 255, 0.9)',
                                fontSize: 'clamp(0.95rem, 1.8vw, 1.15rem)',
                                lineHeight: '1.7',
                                margin: 0
                            }}>
                                <strong style={{ color: '#20b2aa' }}>Works with everything:</strong> BitsBound sits alongside Harvey, your CLM, DocuSign, and whatever else you use.
                                We&apos;re not replacing your stack; we&apos;re completing it. Upload a contract, get partner-grade work product.
                            </p>
                        </div>
                    </div>
                </section>

                {/* INLINE CTA #1: After the stack section */}
                <SignupCta
                    headline="Ready to see BitsBound in action?"
                    sub="Swarm-Powered Redlines • Multi-Pass Drafting • Track Changes • Negotiation emails"
                    authBaseUrl={AUTH_BASE_URL}
                />

                {/* Demo Series Section - Standalone (click-to-play facades, data-driven) */}
                <section className={styles.bubsaSection} id="demo-series">
                    <div className={styles.container}>
                        <div className={styles.sectionHeader}>
                            <div className={styles.sectionLabel} aria-hidden="true">WATCH IT IN ACTION</div>
                            <h2 className={styles.sectionTitle}>
                                The Demo Series
                            </h2>
                            <p className={styles.sectionDescription}>
                                Watch how BitsBound transforms contract review. From platform overview to detailed walkthroughs.
                            </p>
                        </div>

                        <div className={styles.bubsaDownloadSection} style={{ overflow: 'hidden' }}>
                            <div className={styles.bubsaDownloadBox} style={{ overflow: 'hidden' }}>
                                {/* Demo Videos Grid */}
                                <div
                                    ref={demoVideoRef}
                                    style={{
                                        margin: 'clamp(1rem, 4vw, 2rem) auto',
                                        maxWidth: '1200px',
                                        padding: '0',
                                        width: '100%',
                                        boxSizing: 'border-box',
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 320px), 1fr))',
                                        gap: 'clamp(1.5rem, 4vw, 2rem)'
                                    }}>
                                    {DEMO_VIDEOS.map((video) => (
                                        <div key={video.id} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', minWidth: 0, overflow: 'hidden' }}>
                                            <h4 style={{
                                                color: '#20b2aa',
                                                margin: 0,
                                                fontSize: 'clamp(1rem, 2vw, 1.25rem)',
                                                fontWeight: 600
                                            }}>
                                                {video.title}
                                            </h4>
                                            <p style={{
                                                color: 'rgba(255,255,255,0.7)',
                                                margin: 0,
                                                fontSize: 'clamp(0.85rem, 1.5vw, 0.95rem)',
                                                lineHeight: 1.5
                                            }}>
                                                {video.description}
                                            </p>
                                            <LiteYouTubeEmbed videoId={video.id} title={video.title} />
                                        </div>
                                    ))}
                                </div>

                                <div className={styles.bubsaDownloadButtons}>
                                    <a
                                        href="https://www.youtube.com/playlist?list=PLyKYeLjAMfH7436gZ7fn1oYyeLpB40dwV"
                                        className={`${styles.bubsaDownloadButton} ${styles.primaryButton}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: 'none', display: 'inline-block', color: '#ffffff' }}
                                    >
                                        Watch the Full Series on YouTube
                                    </a>
                                    <button
                                        onClick={() => setShowContactModal(true)}
                                        className={`${styles.bubsaDownloadButton} ${styles.secondaryButton}`}
                                        style={{ cursor: 'pointer', border: 'none' }}
                                    >
                                        Contact Us
                                    </button>
                                </div>
                                <p className={styles.bubsaDownloadNote}>
                                    <strong>Target Users:</strong> Founders reviewing vendor contracts • In-house lawyers handling overflow • Boutique firms scaling capacity
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* INLINE CTA #2: After Demo Series */}
                <SignupCta
                    headline="Your next contract could be the demo."
                    authBaseUrl={AUTH_BASE_URL}
                />

                {/* The Swarm - 150+ AI Analyzers Across 9 Contract Types */}
                <section className={styles.bubsaDocsSection}>
                    <div className={styles.container}>
                        <div className={styles.sectionHeader}>
                            <div className={styles.sectionLabel} aria-hidden="true">THE SWARM</div>
                            <h2 className={styles.sectionTitle}>
                                150+ Analyzers, Zero Blind Spots
                            </h2>
                            <p className={styles.sectionDescription}>
                                BitsBound dynamically deploys specialized AI analyzers based on your contract type.
                                Upload any contract; we identify the type and run the right analyzers in parallel.
                            </p>
                        </div>

                        {/* SaaS Agreements */}
                        <div className={styles.bubsaDocsCategory}>
                            <h3 className={styles.bubsaDocsCategoryTitle}>SaaS & Technology <span className={styles.analyzerCount}>17 analyzers</span></h3>
                            <div className={styles.bubsaDocsGrid}>
                                <div className={`${styles.bubsaDocCard} ${styles.revolutionaryCard}`}>
                                    <div className={styles.bubsaDocNumber}>MSA</div>
                                    <div className={styles.revolutionaryBadge}>LIVE</div>
                                    <h4 className={styles.bubsaDocTitle}>SaaS Agreements</h4>
                                    <p className={styles.bubsaDocDescription}>SLA, DPA, IP License, AI Terms, SOW, Warranties, Indemnification</p>
                                </div>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>DPA</div>
                                    <h4 className={styles.bubsaDocTitle}>Data Processing</h4>
                                    <p className={styles.bubsaDocDescription}>GDPR, CCPA, SCCs, subprocessors, breach notification</p>
                                </div>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>SLA</div>
                                    <h4 className={styles.bubsaDocTitle}>Service Levels</h4>
                                    <p className={styles.bubsaDocDescription}>Uptime, response times, service credits, remedies</p>
                                </div>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>AI</div>
                                    <h4 className={styles.bubsaDocTitle}>AI Terms</h4>
                                    <p className={styles.bubsaDocDescription}>Model training, output ownership, usage restrictions</p>
                                </div>
                            </div>
                        </div>

                        {/* M&A */}
                        <div className={styles.bubsaDocsCategory}>
                            <h3 className={styles.bubsaDocsCategoryTitle}>M&A Transactions <span className={styles.analyzerCount}>16 analyzers</span></h3>
                            <div className={styles.bubsaDocsGrid}>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>APA</div>
                                    <h4 className={styles.bubsaDocTitle}>Asset Purchase</h4>
                                    <p className={styles.bubsaDocDescription}>Reps & warranties, closing conditions, earnouts, escrow</p>
                                </div>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>SPA</div>
                                    <h4 className={styles.bubsaDocTitle}>Stock Purchase</h4>
                                    <p className={styles.bubsaDocDescription}>Disclosure schedules, MAC clauses, indemnification caps</p>
                                </div>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>IP</div>
                                    <h4 className={styles.bubsaDocTitle}>IP & Technology</h4>
                                    <p className={styles.bubsaDocDescription}>IP transfer, license-back, employee matters</p>
                                </div>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>COV</div>
                                    <h4 className={styles.bubsaDocTitle}>Covenants</h4>
                                    <p className={styles.bubsaDocDescription}>Pre-closing, post-closing, non-compete, non-solicit</p>
                                </div>
                            </div>
                        </div>

                        {/* VC & Financing */}
                        <div className={styles.bubsaDocsCategory}>
                            <h3 className={styles.bubsaDocsCategoryTitle}>VC & Financing <span className={styles.analyzerCount}>14 analyzers</span></h3>
                            <div className={styles.bubsaDocsGrid}>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>SAFE</div>
                                    <h4 className={styles.bubsaDocTitle}>SAFEs & Notes</h4>
                                    <p className={styles.bubsaDocDescription}>Valuation caps, conversion mechanics, MFN provisions</p>
                                </div>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>SER</div>
                                    <h4 className={styles.bubsaDocTitle}>Series Financing</h4>
                                    <p className={styles.bubsaDocDescription}>Liquidation preferences, anti-dilution, protective provisions</p>
                                </div>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>GOV</div>
                                    <h4 className={styles.bubsaDocTitle}>Governance</h4>
                                    <p className={styles.bubsaDocDescription}>Board composition, information rights, drag-along/tag-along</p>
                                </div>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>FND</div>
                                    <h4 className={styles.bubsaDocTitle}>Founder Terms</h4>
                                    <p className={styles.bubsaDocDescription}>Vesting, acceleration, pro-rata rights</p>
                                </div>
                            </div>
                        </div>

                        {/* Employment & Services */}
                        <div className={styles.bubsaDocsCategory}>
                            <h3 className={styles.bubsaDocsCategoryTitle}>Employment & Services <span className={styles.analyzerCount}>24 analyzers</span></h3>
                            <div className={styles.bubsaDocsGrid}>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>EMP</div>
                                    <h4 className={styles.bubsaDocTitle}>Employment</h4>
                                    <p className={styles.bubsaDocDescription}>Compensation, benefits, restrictive covenants, severance</p>
                                </div>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>SOW</div>
                                    <h4 className={styles.bubsaDocTitle}>Professional Services</h4>
                                    <p className={styles.bubsaDocDescription}>Deliverables, acceptance criteria, change orders, fees</p>
                                </div>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>NDA</div>
                                    <h4 className={styles.bubsaDocTitle}>NDAs</h4>
                                    <p className={styles.bubsaDocDescription}>Confidential info scope, exclusions, term, return/destroy</p>
                                </div>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>IP</div>
                                    <h4 className={styles.bubsaDocTitle}>IP Assignment</h4>
                                    <p className={styles.bubsaDocDescription}>Work product, inventions, moral rights waiver</p>
                                </div>
                            </div>
                        </div>

                        {/* Real Estate & Equipment */}
                        <div className={styles.bubsaDocsCategory}>
                            <h3 className={styles.bubsaDocsCategoryTitle}>Real Estate & Equipment <span className={styles.analyzerCount}>23 analyzers</span></h3>
                            <div className={styles.bubsaDocsGrid}>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>LSE</div>
                                    <h4 className={styles.bubsaDocTitle}>Commercial Lease</h4>
                                    <p className={styles.bubsaDocDescription}>Rent, CAM, TI allowance, renewal options, default/remedies</p>
                                </div>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>EQP</div>
                                    <h4 className={styles.bubsaDocTitle}>Equipment Finance</h4>
                                    <p className={styles.bubsaDocDescription}>Lease vs. purchase, maintenance, end-of-term options</p>
                                </div>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>ENV</div>
                                    <h4 className={styles.bubsaDocTitle}>Environmental</h4>
                                    <p className={styles.bubsaDocDescription}>Phase I, remediation, indemnification, insurance</p>
                                </div>
                                <div className={styles.bubsaDocCard}>
                                    <div className={styles.bubsaDocNumber}>ASN</div>
                                    <h4 className={styles.bubsaDocTitle}>Assignment</h4>
                                    <p className={styles.bubsaDocDescription}>Subletting, consent requirements, recapture rights</p>
                                </div>
                            </div>
                        </div>

                        <div className={styles.bubsaDocsFooter}>
                            <p className={styles.bubsaDocsFooterText}>
                                <strong>Dynamic deployment:</strong> Upload any contract → AI identifies type → deploys relevant analyzers in parallel → produces risk assessments, favorability scores, and redline recommendations
                            </p>
                        </div>
                    </div>
                </section>

                {/* INLINE CTA #3: After 150+ Analyzers */}
                <SignupCta
                    headline="Put 150+ analyzers on your next contract."
                    authBaseUrl={AUTH_BASE_URL}
                />

                {/* Section 2: Who It's For */}
                <section
                    className={`${styles.bubsaSection}`}
                    id="who-section"
                    aria-labelledby="who-section-title"
                    style={{ background: 'linear-gradient(135deg, rgba(32, 178, 170, 0.1) 0%, rgba(255, 215, 0, 0.05) 100%)' }}
                >
                    <div className={styles.container}>
                        <div className={styles.sectionHeader}>
                            <div className={styles.sectionLabel} aria-hidden="true">TARGET USERS</div>
                            <h2
                                id="who-section-title"
                                className={styles.sectionTitle}
                            >
                                Who BitsBound Is For
                            </h2>
                            <p className={styles.sectionDescription} style={{ fontSize: '1.25rem', maxWidth: '800px', margin: '0 auto' }}>
                                Draft, Analyze, Redline, Simulate: for teams that need partner-level output without partner-only bandwidth.
                            </p>
                        </div>

                        {/* Who It's For */}
                        <div style={{ marginTop: '3rem' }}>
                            <div className={styles.bubsaGrid} style={{ maxWidth: '1200px', margin: '0 auto' }}>
                                <div className={`${styles.bubsaCard} ${styles.fadeInView}`}>
                                    <div className={styles.bubsaIcon} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '52px', height: '52px', borderRadius: '14px', background: 'rgba(32, 178, 170, 0.12)', border: '1px solid rgba(32, 178, 170, 0.3)', margin: '0 auto 1rem' }}><Building2 size={26} color="#20b2aa" strokeWidth={2} aria-hidden="true" /></div>
                                    <h3 className={styles.bubsaCardTitle}>In-House Legal Teams</h3>
                                    <p className={styles.bubsaCardDescription}>
                                        At high-growth and enterprise companies using AI to scale capacity without headcount.
                                    </p>
                                </div>

                                <div className={`${styles.bubsaCard} ${styles.fadeInView}`}>
                                    <div className={styles.bubsaIcon} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '52px', height: '52px', borderRadius: '14px', background: 'rgba(32, 178, 170, 0.12)', border: '1px solid rgba(32, 178, 170, 0.3)', margin: '0 auto 1rem' }}><Zap size={26} color="#20b2aa" strokeWidth={2} aria-hidden="true" /></div>
                                    <h3 className={styles.bubsaCardTitle}>Legal Ops & Innovation</h3>
                                    <p className={styles.bubsaCardDescription}>
                                        Teams building the business case for AI and needing proven technology to demonstrate value.
                                    </p>
                                </div>

                                <div className={`${styles.bubsaCard} ${styles.fadeInView}`}>
                                    <div className={styles.bubsaIcon} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '52px', height: '52px', borderRadius: '14px', background: 'rgba(32, 178, 170, 0.12)', border: '1px solid rgba(32, 178, 170, 0.3)', margin: '0 auto 1rem' }}><Briefcase size={26} color="#20b2aa" strokeWidth={2} aria-hidden="true" /></div>
                                    <h3 className={styles.bubsaCardTitle}>Law Firms</h3>
                                    <p className={styles.bubsaCardDescription}>
                                        Wanting partner-quality output without partner-only bandwidth for overflow work.
                                    </p>
                                </div>

                                <div className={`${styles.bubsaCard} ${styles.fadeInView}`}>
                                    <div className={styles.bubsaIcon} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '52px', height: '52px', borderRadius: '14px', background: 'rgba(32, 178, 170, 0.12)', border: '1px solid rgba(32, 178, 170, 0.3)', margin: '0 auto 1rem' }}><Rocket size={26} color="#20b2aa" strokeWidth={2} aria-hidden="true" /></div>
                                    <h3 className={styles.bubsaCardTitle}>Founders & Startups</h3>
                                    <p className={styles.bubsaCardDescription}>
                                        Getting contracts analyzed fast before signing, with professional output to share with counsel.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Pricing Transparency Section - How Credits Work */}
                <section
                    className={`${styles.marketSection} ${styles.fadeInView}`}
                    style={{ background: 'linear-gradient(180deg, rgba(10, 10, 10, 1) 0%, rgba(18, 18, 18, 1) 100%)' }}
                    aria-labelledby="pricing-transparency-title"
                >
                    <div className={styles.container}>
                        <div className={styles.sectionHeader}>
                            <div className={styles.sectionLabel} aria-hidden="true">TRANSPARENT PRICING</div>
                            <h2
                                id="pricing-transparency-title"
                                className={styles.sectionTitle}
                            >
                                How Our Pricing Works
                            </h2>
                            <p className={styles.sectionDescription}>
                                BitsBound uses a <strong className={styles.highlightTeal}>credit-based system</strong> that reflects the actual cost of AI processing.
                                We believe in full transparency: you should know exactly what you're paying for.
                            </p>
                        </div>

                        {/* Pricing Explanation Cards */}
                        <div className={styles.marketVisual}>
                            <div className={styles.marketGrid} style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
                                {/* Credit System Card */}
                                <div className={`${styles.marketStat} ${styles.float}`} style={{ padding: '2rem', textAlign: 'left' }}>
                                    <h3 className={`${styles.marketNumber} ${styles.shimmer}`} style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
                                        Credit System
                                    </h3>
                                    <p style={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: '1.8', fontSize: '0.95rem' }}>
                                        <strong style={{ color: '#20b2aa' }}>$30 per 1 million credits</strong>, flat rate across all tiers.
                                        <br /><br />
                                        <strong style={{ color: '#20b2aa' }}>1 credit = 1 token</strong>. Input and output tokens billed equally.
                                        Usage ranges from &lt;1M (simple NDA draft) to ~30M (complex 70-page redline with high aggressiveness).
                                    </p>
                                </div>

                                {/* Why Output Costs More Card */}
                                <div className={`${styles.marketStat} ${styles.float}`} style={{ padding: '2rem', textAlign: 'left' }}>
                                    <h3 className={`${styles.marketNumber} ${styles.shimmer}`} style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
                                        The Math
                                    </h3>
                                    <p style={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: '1.8', fontSize: '0.95rem' }}>
                                        <strong style={{ color: '#20b2aa' }}>Usage varies by complexity</strong>
                                        <br /><br />
                                        Each contract runs through our full pipeline: 150+ parallel analyzers, multi-pass drafting,
                                        and Instant Swarm redlining. Costs scale with contract length and depth.
                                        <br /><br />
                                        Simple agreement: <strong>~$15-20</strong> • Standard contract: <strong>~$25-30</strong> • Extreme case (70-page redline, maximum aggressiveness, ~30M credits): <strong>up to $900</strong>
                                    </p>
                                </div>

                                {/* Typical Costs Card */}
                                <div className={`${styles.marketStat} ${styles.float}`} style={{ padding: '2rem', textAlign: 'left' }}>
                                    <h3 className={`${styles.marketNumber} ${styles.shimmer}`} style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
                                        Typical Costs
                                    </h3>
                                    <p style={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: '1.8', fontSize: '0.95rem' }}>
                                        <strong style={{ color: '#20b2aa' }}>Simple Agreement (10-20 pages):</strong> ~$15-20
                                        <br />
                                        <strong style={{ color: '#20b2aa' }}>Standard Contract (30-50 pages):</strong> ~$25-30
                                        <br />
                                        <strong style={{ color: '#20b2aa' }}>Complex Enterprise MSA (60+ pages):</strong> ~$35-45
                                        <br /><br />
                                        Costs vary based on contract size and complexity.
                                    </p>
                                </div>

                                {/* Packages Card */}
                                <div className={`${styles.marketStat} ${styles.float}`} style={{ padding: '2rem', textAlign: 'left' }}>
                                    <h3 className={`${styles.marketNumber} ${styles.shimmer}`} style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
                                        Credit Packages
                                    </h3>
                                    <p style={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: '1.8', fontSize: '0.95rem' }}>
                                        <strong style={{ color: '#20b2aa' }}>Tier One:</strong> 1M credits, $30/mo (~1 full analysis)
                                        <br />
                                        <strong style={{ color: '#20b2aa' }}>Tier Two:</strong> 5M credits, $150/mo (~5-6 full analyses)
                                        <br />
                                        <strong style={{ color: '#20b2aa' }}>Tier Three:</strong> 25M credits, $750/mo (~25-30 full analyses)
                                        <br />
                                        <strong style={{ color: '#20b2aa' }}>Tier Four:</strong> 150M credits, $4,500/mo (~150-180 full analyses)
                                        <br /><br />
                                        <strong style={{ color: '#20b2aa' }}>Unlimited Rollover:</strong> Unused credits roll over indefinitely with no cap.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Bottom Note */}
                        <div style={{ textAlign: 'center', marginTop: '2rem', padding: '1.5rem', background: 'rgba(32, 178, 170, 0.1)', borderRadius: '12px', border: '1px solid rgba(32, 178, 170, 0.2)' }}>
                            <p style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.95rem', margin: 0 }}>
                                <strong style={{ color: '#20b2aa' }}>Why we're transparent:</strong> Legal tech pricing is often opaque.
                                We believe you deserve to know exactly what you're paying for and why.
                                Our pricing covers 150+ specialized AI analyzers, Brain A ↔ Brain B consensus, and the engineering that makes contract analysis actually useful.
                            </p>
                        </div>
                    </div>
                </section>
                {/* END OF COMMENTED OUT PODCAST SECTION */}
                <footer className={styles.footer}>
                    <div className={styles.footerContent}>
                        <div className={styles.footerBrand}>
                            <div className={`${styles.footerLogo} ${styles.textGradient}`}>
                                {/* 🟢 Logo image commented out - bb-logo file does not exist */}
                                {/* <img
                                    src={bbLogo}
                                    alt="BitsBound"
                                    className={styles.footerLogoSvg}
                                /> */}
                                <span style={{ fontSize: '2rem', fontWeight: 'bold' }}>BitsBound</span>
                            </div>
                            <p className={styles.footerDescription}>
                                Draft, Analyze, Redline, Simulate. Agentically.
                                Swarm-Powered Redlines & Multi-Pass Drafting for partner-level contracts.
                            </p>
                        </div>
                        <div className={styles.footerBottom}>
                            <p className={styles.footerCopyright}>
                                © 2026 BitsBound, Inc. All rights reserved.
                            </p>
                            <p className={styles.footerDescription} style={{ fontSize: '0.8rem', opacity: 0.85, marginTop: '0.5rem', marginBottom: '0.25rem' }}>
                                Founded and solo-built by Robert J. Taylor, Esq. (PA, NJ &amp; NY Bars, CIPP/E):
                                corporate technology attorney and full-stack AI engineer.
                            </p>
                            <p className={styles.footerDescription} style={{ fontSize: '0.75rem', opacity: 0.8, marginTop: '0.5rem', marginBottom: '0.5rem' }}>
                                BitsBound provides AI-assisted contract analysis tools for legal professionals.
                                All outputs are preliminary drafts requiring attorney review and do not constitute legal advice.
                            </p>
                            <div className={styles.footerLinks}>
                                <a href="/pricing" className={styles.footerLink}>
                                    Pricing
                                </a>
                                <span className={styles.footerSeparator}>•</span>
                                <a href="/about" className={styles.footerLink}>
                                    About
                                </a>
                                <span className={styles.footerSeparator}>•</span>
                                <a href="/documentation" className={styles.footerLink}>
                                    Documentation
                                </a>
                                <span className={styles.footerSeparator}>•</span>
                                <a href="/privacy" className={styles.footerLink}>
                                    Privacy Policy
                                </a>
                                <span className={styles.footerSeparator}>•</span>
                                <a href="/terms" className={styles.footerLink}>
                                    Terms of Service
                                </a>
                                <span className={styles.footerSeparator}>•</span>
                                <a href="/security" className={styles.footerLink}>
                                    Security
                                </a>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </>
    );
}

// XI. EXPORTS
// ⚫ [Subsection 91: BLACK] Rob, PropTypes removed - TypeScript interfaces replace them!
/* PropTypes removed in favor of TypeScript interfaces
Pea_Homepage.propTypes = {
    // Navigation state
    isNavScrolled: PropTypes.bool,

    // Compiler demo props
    selectedOPL: PropTypes.string,
    legalTextInput: PropTypes.string,
    compiledOutput: PropTypes.string,
    isCompiling: PropTypes.bool,
    onOPLChange: PropTypes.func,
    onLegalTextChange: PropTypes.func,
    onLoadExample: PropTypes.func,
    onAnalyze: PropTypes.func,
    syntaxHighlight: PropTypes.func,

    // Testimonial carousel props
    testimonials: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            author: PropTypes.string.isRequired,
            role: PropTypes.string.isRequired,
            company: PropTypes.string.isRequired,
            content: PropTypes.string.isRequired,
            rating: PropTypes.number,
            avatar: PropTypes.string,
            avatarGradient: PropTypes.string,
        }),
    ),
    currentTestimonialIndex: PropTypes.number,
    isCarouselPaused: PropTypes.bool,
    onNextTestimonial: PropTypes.func,
    onPrevTestimonial: PropTypes.func,
    onGoToTestimonial: PropTypes.func,
    onToggleCarouselPause: PropTypes.func,

    // Animation props
    mousePosition: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number,
    }),
    typewriterPhrases: PropTypes.arrayOf(PropTypes.string),
    animationConfig: PropTypes.shape({
        PARTICLE_COUNT: PropTypes.number,
        NEURAL_NODE_COUNT: PropTypes.number,
        MATRIX_FONT_SIZE: PropTypes.number,
        CAROUSEL_INTERVAL: PropTypes.number,
        TYPEWRITER_SPEED: PropTypes.number,
        TYPEWRITER_BACK_SPEED: PropTypes.number,
        TYPEWRITER_BACK_DELAY: PropTypes.number,
    }),

    // Canvas refs for animations
    threeSceneRef: PropTypes.object,
    particlesRef: PropTypes.object,
    neuralCanvasRef: PropTypes.object,
    matrixCanvasRef: PropTypes.object,

    // Navigation handler
    onBookDemoNavigate: PropTypes.func,

    // AI booking assistant handler
    onAIBookingAssist: PropTypes.func,

    // Visibility tracking
    visibleSections: PropTypes.object,
    scrollProgress: PropTypes.number,

    // UI customization
    className: PropTypes.string,
};
*/

// ⚫ [Subsection 100: BLACK] Rob, exporting typed component with full TypeScript support!
export default Pea_Homepage;
